import * as _ from 'lodash';
import { AbstractControl, ValidatorFn } from '@angular/forms';

import { languageLookup, packageTypeLookup, whmisCodeLookup } from 'shared/product/product-lookups';
import { countryLookup, yesNoLookup } from 'utils/lookups';
import patterns from 'utils/patterns';
import { isLookupOption } from 'shared/validation/select-validation';

import { SegmentFieldItem } from 'utils/segment-field-item.interface';
import { gtinValidation } from 'shared/validation/gtin-validation';

const weightVarianceValidationText = 'Weight variance (%) must be greater than 0 and less than 8 digits including 4 decimal places.';
const dimensionalWeightValidationText = 'Dimensional weight must be greater than 0 and less than 9 characters including 4 decimal places.';

/* eslint-disable */
export const packagesSegmentData: Array<SegmentFieldItem> = [
  // added fields
  {
      "field_map": "packageUom",
      "item_name": "packageUom",
      "title": "Package type",
      "hint_detail": "",
      "hint_panel" : "",
      "example": "",
      "sequence": 1,
      "show_more": true,
      "lookup": packageTypeLookup,
  },
  {
      "field_map": "packageUomTitle",
      "item_name": "packageUomTitle",
      "title": "Package type",
      "hint_detail": "",
      "hint_panel" : "",
      "example": "",
      "sequence": 1,
      "show_more": true,
      "lookup": packageTypeLookup,
  },
// --------------
  {
      "field_map": "title",
      "item_name": "EA.title",
      "title": "Package title",
      "hint_detail": "Smallest pack (consumer level)",
      "hint_panel" : "Smallest pack (consumer level)",
      "example": "",
      "sequence": 1,
      "show_more": true,
      "lookup": null,
  },
  {
      "field_map": "title",
      "item_name": "PK.title",
      "title": "Package type",
      "hint_detail": "The shippable inner package",
      "hint_panel" : "The shippable inner package",
      "example": "",
      "sequence": 1,
      "show_more": true,
      "lookup": null,
  },
  {
      "field_map": "title",
      "item_name": "BX.title",
      "title": "Package type",
      "hint_detail": "Inner pack (non-shippable)",
      "hint_panel" : "Inner pack (non-shippable)",
      "example": "",
      "sequence": 1,
      "show_more": true,
      "lookup": null,
  },
  {
      "field_map": "title",
      "item_name": "CA.title",
      "title": "Package type",
      "hint_detail": "Case",
      "hint_panel" : "Case",
      "example": "",
      "sequence": 1,
      "show_more": true,
      "lookup": null,
  },
  {
      "field_map": "title",
      "item_name": "PL.title",
      "title": "Package type",
      "hint_detail": "Pallet",
      "hint_panel" : "Pallet",
      "example": "",
      "sequence": 1,
      "show_more": true,
      "lookup": null,
  },
  {
      "field_map": "orderable",
      "item_name": "EA.orderable",
      "title": "Orderable",
      "hint_detail": "YES or NO if this package is orderable.",
      "hint_panel" : "YES or NO if this package is orderable.",
      "example": "",
      "sequence": 2,
      "show_more": true,
      "lookup": [
        {
          "option": "",
          "title": "-"
        },
        {
          "option": "N",
          "title": "No",
        },
        {
          "option": "Y",
          "title": "Yes",
        }
      ]
  },
  {
      "field_map": "orderable",
      "item_name": "PK.orderable",
      "title": "Orderable",
      "hint_detail": "YES or NO if this package is orderable.",
      "hint_panel" : "YES or NO if this package is orderable.",
      "example": "",
      "sequence": 2,
      "show_more": true,
      "lookup": [
        {
          "option": "",
          "title": "-"
        },
        {
          "option": "N",
          "title": "No",
        },
        {
          "option": "Y",
          "title": "Yes",
        }
      ]
  },
  {
      "field_map": "orderable",
      "item_name": "BX.orderable",
      "title": "Orderable",
      "hint_detail": "YES or NO if this package is orderable.",
      "hint_panel" : "YES or NO if this package is orderable.",
      "example": "",
      "sequence": 2,
      "show_more": true,
      "lookup": [
        {
          "option": "",
          "title": "-"
        },
        {
          "option": "N",
          "title": "No",
        },
        {
          "option": "Y",
          "title": "Yes",
        }
      ]
  },
  {
      "field_map": "orderable",
      "item_name": "CA.orderable",
      "title": "Orderable",
      "hint_detail": "YES or NO if this package is orderable.",
      "hint_panel" : "YES or NO if this package is orderable.",
      "example": "",
      "sequence": 2,
      "show_more": true,
      "lookup": [
        {
          "option": "",
          "title": "-"
        },
        {
          "option": "N",
          "title": "No",
        },
        {
          "option": "Y",
          "title": "Yes",
        }
      ]
  },
  {
      "field_map": "orderable",
      "item_name": "PL.orderable",
      "title": "Orderable",
      "hint_detail": "YES or NO if this package is orderable.",
      "hint_panel" : "YES or NO if this package is orderable.",
      "example": "",
      "sequence": 2,
      "show_more": true,
      "lookup": [
        {
          "option": "",
          "title": "-"
        },
        {
          "option": "N",
          "title": "No",
        },
        {
          "option": "Y",
          "title": "Yes",
        }
      ]
  },
  {
      "field_map": "quantity",
      "item_name": "EA.quantity",
      "title": "Each per package",
      "hint_detail": "Number of items per package",
      "hint_panel" : "Number of items per package",
      "example": "1",
      "sequence": 3,
      "show_more": true,
      'numerical': true,
      'validation': {
        'pies65' : {
          max: 99999999,
          message: 'Minimum quantity must be less then 99999999.'
        }
      },
      "lookup": null
  },
  {
      "field_map": "quantity",
      "item_name": "PK.quantity",
      "title": "Each per package",
      "hint_detail": "Number of items per package",
      "hint_panel" : "Number of items per package",
      "example": "1",
      "sequence": 3,
      "show_more": true,
      'numerical': true,
      'validation': {
        'pies65' : {
          max: 99999999,
          message: 'Minimum quantity must be less then 99999999.'
        }
      },
      "lookup": null
  },
  {
      "field_map": "quantity",
      "item_name": "BX.quantity",
      "title": "Each per package",
      "hint_detail": "Number of items per package",
      "hint_panel" : "Number of items per package",
      "example": "1",
      "sequence": 3,
      "show_more": true,
      'numerical': true,
      'validation': {
        'pies65' : {
          max: 99999999,
          message: 'Minimum quantity must be less then 99999999.'
        }
      },
      "lookup": null
  },
  {
      "field_map": "quantity",
      "item_name": "CA.quantity",
      "title": "Each per package",
      "hint_detail": "Number of items per package",
      "hint_panel" : "Number of items per package",
      "example": "3",
      "sequence": 3,
      "show_more": true,
      'numerical': true,
      'validation': {
        'pies65' : {
          max: 99999999,
          message: 'Minimum quantity must be less then 99999999.'
        }
      },
      "lookup": null
  },
  {
      "field_map": "quantity",
      "item_name": "PL.quantity",
      "title": "Each per package",
      "hint_detail": "Number of items per package",
      "hint_panel" : "Number of items per package",
      "example": "4",
      "sequence": 3,
      "show_more": true,
      'numerical': true,
      'validation': {
        'pies65' : {
          max: 99999999,
          message: 'Minimum quantity must be less then 99999999.'
        }
      },
      "lookup": null
  },
  {
      "field_map": "dimensionsLength",
      "item_name": "EA.dimensions.length",
      "title": "Length",
      "hint_detail": "Length of the package with the product on its natural base and the graphics reading from left to right from the front.",
      "hint_panel" : "Length (also depth) is the front-to-back Horizontal dimension. Put the product on its natural base, with the graphics reading from left to right from the front. Note: This relates to how the product is merchandised, and it is possible it is packed for distribution in a different orientation.",
      "example": "7.775",
      "sequence": 4,
      "show_more": true,
      'numerical': true,
      'digits_limit': 8,
      'validation': {
        'pies65' : {
          min: 0,
          pattern: patterns.N4_8,
          message: 'Length must be greater than 0 and less than 8 characters including 4 decimal places.'
        }
      },
      "lookup": null
  },
  {
      "field_map": "dimensionsLength",
      "item_name": "PK.dimensions.length",
      "title": "Length",
      "hint_detail": "Length of the package with the product on its natural base and the graphics reading from left to right from the front.",
      "hint_panel" : "Length (also depth) is the front-to-back Horizontal dimension. Put the product on its natural base, with the graphics reading from left to right from the front. Note: This relates to how the product is merchandised, and it is possible it is packed for distribution in a different orientation.",
      "example": "7.775",
      "sequence": 4,
      "show_more": true,
      'numerical': true,
      'digits_limit': 8,
      'validation': {
        'pies65' : {
          min: 0,
          pattern: patterns.N4_8,
          message: 'Length must be greater than 0 and less than 8 characters including 4 decimal places.'
        }
      },
      "lookup": null
  },
  {
      "field_map": "dimensionsLength",
      "item_name": "BX.dimensions.length",
      "title": "Length",
      "hint_detail": "Length of the package with the product on its natural base and the graphics reading from left to right from the front.",
      "hint_panel" : "Length (also depth) is the front-to-back Horizontal dimension. Put the product on its natural base, with the graphics reading from left to right from the front. Note: This relates to how the product is merchandised, and it is possible it is packed for distribution in a different orientation.",
      "example": "7.775",
      "sequence": 4,
      "show_more": true,
      'numerical': true,
      'digits_limit': 8,
      'validation': {
        'pies65' : {
          min: 0,
          pattern: patterns.N4_8,
          message: 'Length must be greater than 0 and less than 8 characters including 4 decimal places.'
        }
      },
      "lookup": null
  },
  {
      "field_map": "dimensionsLength",
      "item_name": "CA.dimensions.length",
      "title": "Length",
      "hint_detail": "Length of the package with the product on its natural base and the graphics reading from left to right from the front.",
      "hint_panel" : "Length (also depth) is the front-to-back Horizontal dimension. Put the product on its natural base, with the graphics reading from left to right from the front. Note: This relates to how the product is merchandised, and it is possible it is packed for distribution in a different orientation.",
      "example": "7.775",
      "sequence": 4,
      "show_more": true,
      'numerical': true,
      'digits_limit': 8,
      'validation': {
        'pies65' : {
          min: 0,
          pattern: patterns.N4_8,
          message: 'Length must be greater than 0 and less than 8 characters including 4 decimal places.'
        }
      },
      "lookup": null
  },
  {
      "field_map": "dimensionsLength",
      "item_name": "PL.dimensions.length",
      "title": "Length",
      "hint_detail": "Length of the package with the product on its natural base and the graphics reading from left to right from the front.",
      "hint_panel" : "Length (also depth) is the front-to-back Horizontal dimension. Put the product on its natural base, with the graphics reading from left to right from the front. Note: This relates to how the product is merchandised, and it is possible it is packed for distribution in a different orientation.",
      "example": "7.775",
      "sequence": 4,
      "show_more": true,
      'numerical': true,
      'digits_limit': 8,
      'validation': {
        'pies65' : {
          min: 0,
          pattern: patterns.N4_8,
          message: 'Length must be greater than 0 and less than 8 characters including 4 decimal places.'
        }
      },
      "lookup": null
  },
  {
      "field_map": "dimensionsWidth",
      "item_name": "EA.dimensions.width",
      "title": "Width",
      "hint_detail": "Width of the package with the product on its natural base, with the graphics reading from left to right from the front.",
      "hint_panel" : "Width is the left-to-right Horizontal dimension. Put the product on its natural base, with the graphics reading from left to right from the front. Note: This relates to how the product is merchandised, and it is possible it is packed for distribution in a different orientation.",
      "example": "1.725",
      "sequence": 5,
      "show_more": true,
      'numerical': true,
      'digits_limit': 8,
      'validation': {
        'pies65' : {
          min: 0,
          pattern: patterns.N4_8,
          message: 'Width must be greater than 0 and less than 8 characters including 4 decimal places.'
        }
      },
      "lookup": null
  },
  {
      "field_map": "dimensionsWidth",
      "item_name": "PK.dimensions.width",
      "title": "Width",
      "hint_detail": "Width of the package with the product on its natural base, with the graphics reading from left to right from the front.",
      "hint_panel" : "Width is the left-to-right Horizontal dimension. Put the product on its natural base, with the graphics reading from left to right from the front. Note: This relates to how the product is merchandised, and it is possible it is packed for distribution in a different orientation.",
      "example": "1.725",
      "sequence": 5,
      "show_more": true,
      'numerical': true,
      'digits_limit': 8,
      'validation': {
        'pies65' : {
          min: 0,
          pattern: patterns.N4_8,
          message: 'Width must be greater than 0 and less than 8 characters including 4 decimal places.'
        }
      },
      "lookup": null
  },
  {
      "field_map": "dimensionsWidth",
      "item_name": "BX.dimensions.width",
      "title": "Width",
      "hint_detail": "Width of the package with the product on its natural base, with the graphics reading from left to right from the front.",
      "hint_panel" : "Width is the left-to-right Horizontal dimension. Put the product on its natural base, with the graphics reading from left to right from the front. Note: This relates to how the product is merchandised, and it is possible it is packed for distribution in a different orientation.",
      "example": "1.725",
      "sequence": 5,
      "show_more": true,
      'numerical': true,
      'digits_limit': 8,
      'validation': {
        'pies65' : {
          min: 0,
          pattern: patterns.N4_8,
          message: 'Width must be greater than 0 and less than 8 characters including 4 decimal places.'
        }
      },
      "lookup": null
  },
  {
      "field_map": "dimensionsWidth",
      "item_name": "CA.dimensions.width",
      "title": "Width",
      "hint_detail": "Width of the package with the product on its natural base, with the graphics reading from left to right from the front.",
      "hint_panel" : "Width is the left-to-right Horizontal dimension. Put the product on its natural base, with the graphics reading from left to right from the front. Note: This relates to how the product is merchandised, and it is possible it is packed for distribution in a different orientation.",
      "example": "1.725",
      "sequence": 5,
      "show_more": true,
      'numerical': true,
      'digits_limit': 8,
      'validation': {
        'pies65' : {
          min: 0,
          pattern: patterns.N4_8,
          message: 'Width must be greater than 0 and less than 8 characters including 4 decimal places.'
        }
      },
      "lookup": null
  },
  {
      "field_map": "dimensionsWidth",
      "item_name": "PL.dimensions.width",
      "title": "Width",
      "hint_detail": "Width of the package with the product on its natural base, with the graphics reading from left to right from the front.",
      "hint_panel" : "Width is the left-to-right Horizontal dimension. Put the product on its natural base, with the graphics reading from left to right from the front. Note: This relates to how the product is merchandised, and it is possible it is packed for distribution in a different orientation.",
      "example": "1.725",
      "sequence": 5,
      "show_more": true,
      'numerical': true,
      'digits_limit': 8,
      'validation': {
        'pies65' : {
          min: 0,
          pattern: patterns.N4_8,
          message: 'Width must be greater than 0 and less than 8 characters including 4 decimal places.'
        }
      },
      "lookup": null
  },
  {
      "field_map": "dimensionsHeight",
      "item_name": "EA.dimensions.height",
      "title": "Height",
      "hint_detail": "Height of the package with the product on its natural base, with the graphics reading from left to right from the front.",
      "hint_panel" : "Height = base to top. Put the product on its natural base, with the graphics reading from left to right from the front. Note: This relates to how the product is merchandised, and it is possible it is packed for distribution in a different orientation.",
      "example": "12.225",
      "sequence": 6,
      "show_more": true,
      'numerical': true,
      'digits_limit': 8,
      'validation': {
        'pies65' : {
          min: 0,
          pattern: patterns.N4_8,
          message: 'Height must be greater than 0 and less than 8 characters including 4 decimal places.'
        }
      },
      "lookup": null
  },
  {
      "field_map": "dimensionsHeight",
      "item_name": "PK.dimensions.height",
      "title": "Height",
      "hint_detail": "Height of the package with the product on its natural base, with the graphics reading from left to right from the front.",
      "hint_panel" : "Height = base to top. Put the product on its natural base, with the graphics reading from left to right from the front. Note: This relates to how the product is merchandised, and it is possible it is packed for distribution in a different orientation.",
      "example": "12.225",
      "sequence": 6,
      "show_more": true,
      'numerical': true,
      'digits_limit': 8,
      'validation': {
        'pies65' : {
          min: 0,
          pattern: patterns.N4_8,
          message: 'Height must be greater than 0 and less than 8 characters including 4 decimal places.'
        }
      },
      "lookup": null
  },
  {
      "field_map": "dimensionsHeight",
      "item_name": "BX.dimensions.height",
      "title": "Height",
      "hint_detail": "Height of the package with the product on its natural base, with the graphics reading from left to right from the front.",
      "hint_panel" : "Height = base to top. Put the product on its natural base, with the graphics reading from left to right from the front. Note: This relates to how the product is merchandised, and it is possible it is packed for distribution in a different orientation.",
      "example": "12.225",
      "sequence": 6,
      "show_more": true,
      'numerical': true,
      'digits_limit': 8,
      'validation': {
        'pies65' : {
          min: 0,
          pattern: patterns.N4_8,
          message: 'Height must be greater than 0 and less than 8 characters including 4 decimal places.'
        }
      },
      "lookup": null
  },
  {
      "field_map": "dimensionsHeight",
      "item_name": "CA.dimensions.height",
      "title": "Height",
      "hint_detail": "Height of the package with the product on its natural base, with the graphics reading from left to right from the front.",
      "hint_panel" : "Height = base to top. Put the product on its natural base, with the graphics reading from left to right from the front. Note: This relates to how the product is merchandised, and it is possible it is packed for distribution in a different orientation.",
      "example": "12.225",
      "sequence": 6,
      "show_more": true,
      'numerical': true,
      'digits_limit': 8,
      'validation': {
        'pies65' : {
          min: 0,
          pattern: patterns.N4_8,
          message: 'Height must be greater than 0 and less than 8 characters including 4 decimal places.'
        }
      },
      "lookup": null
  },
  {
      "field_map": "dimensionsHeight",
      "item_name": "PL.dimensions.height",
      "title": "Height",
      "hint_detail": "Height of the package with the product on its natural base, with the graphics reading from left to right from the front.",
      "hint_panel" : "Height = base to top. Put the product on its natural base, with the graphics reading from left to right from the front. Note: This relates to how the product is merchandised, and it is possible it is packed for distribution in a different orientation.",
      "example": "12.225",
      "sequence": 6,
      "show_more": true,
      'numerical': true,
      'digits_limit': 8,
      'validation': {
        'pies65' : {
          min: 0,
          pattern: patterns.N4_8,
          message: 'Height must be greater than 0 and less than 8 characters including 4 decimal places.'
        }
      },
      "lookup": null
  },
  {
      "field_map": "dimensionsUom",
      "item_name": "EA.dimensions.uom",
      "title": "Dimensions unit measurement",
      "hint_detail": "Units of measurement for package dimensions. Inches and centimeters are the only two options. ",
      "hint_panel" : "Choose inches or centimeters as the unit of measurement for package dimensions. These are the only two available options. ",
      "example": "inches",
      "sequence": 7,
      "show_more": true,
      'validation': {
        'pies65' : {
          required: true,
          message: 'Dimensions unit of measurement is required.'
        }
      },
      "lookup": [
        {
          "option": "",
          "title": "-"
        },
        {
          "option": "IN",
          "title": "in"
        },
        {
          "option": "CM",
          "title": "cm"
        }
      ]
  },
  {
      "field_map": "dimensionsUom",
      "item_name": "PK.dimensions.uom",
      "title": "Dimensions unit measurement",
      "hint_detail": "Units of measurement for package dimensions. Inches and centimeters are the only two options. ",
      "hint_panel" : "Choose inches or centimeters as the unit of measurement for package dimensions. These are the only two available options. ",
      "example": "inches",
      "sequence": 7,
      "show_more": true,
      'validation': {
        'pies65' : {
          required: true,
          message: 'Dimensions unit of measurement is required.'
        }
      },
      "lookup": [
        {
          "option": "",
          "title": "-"
        },
        {
          "option": "IN",
          "title": "in"
        },
        {
          "option": "CM",
          "title": "cm"
        }
      ]
  },
  {
      "field_map": "dimensionsUom",
      "item_name": "BX.dimensions.uom",
      "title": "Dimensions unit measurement",
      "hint_detail": "Units of measurement for package dimensions. Inches and centimeters are the only two options. ",
      "hint_panel" : "Choose inches or centimeters as the unit of measurement for package dimensions. These are the only two available options. ",
      "example": "inches",
      "sequence": 7,
      "show_more": true,
      'validation': {
        'pies65' : {
          required: true,
          message: 'Dimensions unit of measurement is required.'
        }
      },
      "lookup": [
        {
          "option": "",
          "title": "-"
        },
        {
          "option": "IN",
          "title": "in"
        },
        {
          "option": "CM",
          "title": "cm"
        }
      ]
  },
  {
      "field_map": "dimensionsUom",
      "item_name": "CA.dimensions.uom",
      "title": "Dimensions unit measurement",
      "hint_detail": "Units of measurement for package dimensions. Inches and centimeters are the only two options. ",
      "hint_panel" : "Choose inches or centimeters as the unit of measurement for package dimensions. These are the only two available options. ",
      "example": "inches",
      "sequence": 7,
      "show_more": true,
      'validation': {
        'pies65' : {
          required: true,
          message: 'Dimensions unit of measurement is required.'
        }
      },
      "lookup": [
        {
          "option": "",
          "title": "-"
        },
        {
          "option": "IN",
          "title": "in"
        },
        {
          "option": "CM",
          "title": "cm"
        }
      ]
  },
  {
      "field_map": "dimensionsUom",
      "item_name": "PL.dimensions.uom",
      "title": "Dimensions unit measurement",
      "hint_detail": "Units of measurement for package dimensions. Inches and centimeters are the only two options. ",
      "hint_panel" : "Choose inches or centimeters as the unit of measurement for package dimensions. These are the only two available options. ",
      "example": "inches",
      "sequence": 7,
      "show_more": true,
      'validation': {
        'pies65' : {
          required: true,
          message: 'Dimensions unit of measurement is required.'
        }
      },
      "lookup": [
        {
          "option": "",
          "title": "-"
        },
        {
          "option": "IN",
          "title": "in"
        },
        {
          "option": "CM",
          "title": "cm"
        }
      ]
  },
  {
      "field_map": "weightVariance",
      "item_name": "EA.weight_variance",
      "title": "Weight variance (%)",
      "hint_detail": "Potential variance in package weight expressed as a percentage.",
      "hint_panel" : "Enter the potential variance in package weight expressed as a percentage.",
      "example": "3.25%",
      "sequence": 8,
      "show_more": true,
      'numerical': true,
      'digits_limit': 8,
      'validation': {
        'pies65' : {
          min: 0,
          pattern: patterns.N4_8,
          message: weightVarianceValidationText,
        }
      },
      "lookup": null
  },
  {
      "field_map": "weightVariance",
      "item_name": "PK.weight_variance",
      "title": "Weight variance (%)",
      "hint_detail": "Potential variance in package weight expressed as a percentage.",
      "hint_panel" : "Enter the potential variance in package weight expressed as a percentage.",
      "example": "3.25%",
      "sequence": 8,
      "show_more": true,
      'numerical': true,
      'digits_limit': 8,
      'validation': {
        'pies65' : {
          min: 0,
          pattern: patterns.N4_8,
          message: weightVarianceValidationText,
        }
      },
      "lookup": null
  },
  {
      "field_map": "weightVariance",
      "item_name": "BX.weight_variance",
      "title": "Weight variance (%)",
      "hint_detail": "Potential variance in package weight expressed as a percentage.",
      "hint_panel" : "Enter the potential variance in package weight expressed as a percentage.",
      "example": "3.25%",
      "sequence": 8,
      "show_more": true,
      'numerical': true,
      'digits_limit': 8,
      'validation': {
        'pies65' : {
          min: 0,
          pattern: patterns.N4_8,
          message: weightVarianceValidationText,
        }
      },
      "lookup": null
  },
  {
      "field_map": "weightVariance",
      "item_name": "CA.weight_variance",
      "title": "Weight variance (%)",
      "hint_detail": "Potential variance in package weight expressed as a percentage.",
      "hint_panel" : "Enter the potential variance in package weight expressed as a percentage.",
      "example": "3.25%",
      "sequence": 8,
      "show_more": true,
      'numerical': true,
      'digits_limit': 8,
      'validation': {
        'pies65' : {
          min: 0,
          pattern: patterns.N4_8,
          message: weightVarianceValidationText,
        }
      },
      "lookup": null
  },
  {
      "field_map": "weightVariance",
      "item_name": "PL.weight_variance",
      "title": "Weight variance (%)",
      "hint_detail": "Potential variance in package weight expressed as a percentage.",
      "hint_panel" : "Enter the potential variance in package weight expressed as a percentage.",
      "example": "3.25%",
      "sequence": 8,
      "show_more": true,
      'numerical': true,
      'digits_limit': 8,
      'validation': {
        'pies65' : {
          min: 0,
          pattern: patterns.N4_8,
          message: weightVarianceValidationText,
        }
      },
      "lookup": null
  },
  // shippingHeight
  {
      "field_map": "shippingHeight",
      "item_name": "EA.dimensions.shipping_height",
      "title": "Shipping Height",
      "hint_detail": "Hint: Package Shipping Height.",
      "hint_panel" : "Hint: Package Shipping Height.",
      "example": "",
      "sequence": 8,
      "show_more": true,
      'numerical': true,
      'digits_limit': 8,
      'validation': {
        'pies65' : {
          min: 0,
          pattern: patterns.N4_8,
          message: '',
        }
      },
      "lookup": null
  },
  {
      "field_map": "shippingHeight",
      "item_name": "PK.dimensions.shipping_height",
      "title": "Shipping Height",
      "hint_detail": "Hint: Package Shipping Height.",
      "hint_panel" : "Hint: Package Shipping Height.",
      "example": "",
      "sequence": 8,
      "show_more": true,
      'numerical': true,
      'digits_limit': 8,
      'validation': {
        'pies65' : {
          min: 0,
          pattern: patterns.N4_8,
          message: '',
        }
      },
      "lookup": null
  },
  {
      "field_map": "shippingHeight",
      "item_name": "BX.dimensions.shipping_height",
      "title": "Shipping Height",
      "hint_detail": "Hint: Package Shipping Height.",
      "hint_panel" : "Hint: Package Shipping Height.",
      "example": "",
      "sequence": 8,
      "show_more": true,
      'numerical': true,
      'digits_limit': 8,
      'validation': {
        'pies65' : {
          min: 0,
          pattern: patterns.N4_8,
          message: '',
        }
      },
      "lookup": null
  },
  {
      "field_map": "shippingHeight",
      "item_name": "CA.dimensions.shipping_height",
      "title": "Shipping Height",
      "hint_detail": "Hint: Package Shipping Height.",
      "hint_panel" : "Hint: Package Shipping Height.",
      "example": "",
      "sequence": 8,
      "show_more": true,
      'numerical': true,
      'digits_limit': 8,
      'validation': {
        'pies65' : {
          min: 0,
          pattern: patterns.N4_8,
          message: '',
        }
      },
      "lookup": null
  },
  {
      "field_map": "shippingHeight",
      "item_name": "PL.dimensions.shipping_height",
      "title": "Shipping Height",
      "hint_detail": "Hint: Package Shipping Height.",
      "hint_panel" : "Hint: Package Shipping Height.",
      "example": "",
      "sequence": 8,
      "show_more": true,
      'numerical': true,
      'digits_limit': 8,
      'validation': {
        'pies65' : {
          min: 0,
          pattern: patterns.N4_8,
          message: '',
        }
      },
      "lookup": null
  },
  // shippingWidth
  {
      "field_map": "shippingWidth",
      "item_name": "EA.dimensions.shipping_width",
      "title": "Shipping Width",
      "hint_detail": "Hint: Package Shipping Width.",
      "hint_panel" : "Hint: Package Shipping Width.",
      "example": "",
      "sequence": 8,
      "show_more": true,
      'numerical': true,
      'digits_limit': 8,
      'validation': {
        'pies65' : {
          min: 0,
          pattern: patterns.N4_8,
          message: '',
        }
      },
      "lookup": null
  },
  {
      "field_map": "shippingWidth",
      "item_name": "PK.dimensions.shipping_width",
      "title": "Shipping Width",
      "hint_detail": "Hint: Package Shipping Width.",
      "hint_panel" : "Hint: Package Shipping Width.",
      "example": "",
      "sequence": 8,
      "show_more": true,
      'numerical': true,
      'digits_limit': 8,
      'validation': {
        'pies65' : {
          min: 0,
          pattern: patterns.N4_8,
          message: '',
        }
      },
      "lookup": null
  },
  {
      "field_map": "shippingWidth",
      "item_name": "BX.dimensions.shipping_width",
      "title": "Shipping Width",
      "hint_detail": "Hint: Package Shipping Width.",
      "hint_panel" : "Hint: Package Shipping Width.",
      "example": "",
      "sequence": 8,
      "show_more": true,
      'numerical': true,
      'digits_limit': 8,
      'validation': {
        'pies65' : {
          min: 0,
          pattern: patterns.N4_8,
          message: '',
        }
      },
      "lookup": null
  },
  {
      "field_map": "shippingWidth",
      "item_name": "CA.dimensions.shipping_width",
      "title": "Shipping Width",
      "hint_detail": "Hint: Package Shipping Width.",
      "hint_panel" : "Hint: Package Shipping Width.",
      "example": "",
      "sequence": 8,
      "show_more": true,
      'numerical': true,
      'digits_limit': 8,
      'validation': {
        'pies65' : {
          min: 0,
          pattern: patterns.N4_8,
          message: '',
        }
      },
      "lookup": null
  },
  {
      "field_map": "shippingWidth",
      "item_name": "PL.dimensions.shipping_width",
      "title": "Shipping Width",
      "hint_detail": "Hint: Package Shipping Width.",
      "hint_panel" : "Hint: Package Shipping Width.",
      "example": "",
      "sequence": 8,
      "show_more": true,
      'numerical': true,
      'digits_limit': 8,
      'validation': {
        'pies65' : {
          min: 0,
          pattern: patterns.N4_8,
          message: '',
        }
      },
      "lookup": null
  },
  // shippingLength
  {
      "field_map": "shippingLength",
      "item_name": "EA.dimensions.shipping_length",
      "title": "Shipping Length",
      "hint_detail": "Hint: Package Shipping Length.",
      "hint_panel" : "Hint: Package Shipping Length.",
      "example": "",
      "sequence": 8,
      "show_more": true,
      'numerical': true,
      'digits_limit': 8,
      'validation': {
        'pies65' : {
          min: 0,
          pattern: patterns.N4_8,
          message: '',
        }
      },
      "lookup": null
  },
  {
      "field_map": "shippingLength",
      "item_name": "PK.dimensions.shipping_length",
      "title": "Shipping Length",
      "hint_detail": "Hint: Package Shipping Length.",
      "hint_panel" : "Hint: Package Shipping Length.",
      "example": "",
      "sequence": 8,
      "show_more": true,
      'numerical': true,
      'digits_limit': 8,
      'validation': {
        'pies65' : {
          min: 0,
          pattern: patterns.N4_8,
          message: '',
        }
      },
      "lookup": null
  },
  {
      "field_map": "shippingLength",
      "item_name": "BX.dimensions.shipping_length",
      "title": "Shipping Length",
      "hint_detail": "Hint: Package Shipping Length.",
      "hint_panel" : "Hint: Package Shipping Length.",
      "example": "",
      "sequence": 8,
      "show_more": true,
      'numerical': true,
      'digits_limit': 8,
      'validation': {
        'pies65' : {
          min: 0,
          pattern: patterns.N4_8,
          message: '',
        }
      },
      "lookup": null
  },
  {
      "field_map": "shippingLength",
      "item_name": "CA.dimensions.shipping_length",
      "title": "Shipping Length",
      "hint_detail": "Hint: Package Shipping Length.",
      "hint_panel" : "Hint: Package Shipping Length.",
      "example": "",
      "sequence": 8,
      "show_more": true,
      'numerical': true,
      'digits_limit': 8,
      'validation': {
        'pies65' : {
          min: 0,
          pattern: patterns.N4_8,
          message: '',
        }
      },
      "lookup": null
  },
  {
      "field_map": "shippingLength",
      "item_name": "PL.dimensions.shipping_length",
      "title": "Shipping Length",
      "hint_detail": "Hint: Package Shipping Length.",
      "hint_panel" : "Hint: Package Shipping Length.",
      "example": "",
      "sequence": 8,
      "show_more": true,
      'numerical': true,
      'digits_limit': 8,
      'validation': {
        'pies65' : {
          min: 0,
          pattern: patterns.N4_8,
          message: '',
        }
      },
      "lookup": null
  },
  {
      "field_map": "weight",
      "item_name": "EA.weights.weight",
      "title": "Weight",
      "hint_detail": "Gross weight per package.",
      "hint_panel" : "Enter the gross weight of this package.",
      "example": "1.08",
      "sequence": 9,
      "show_more": true,
      'numerical': true,
      'digits_limit': 9,
      'validation': {
        'pies65' : {
          min: 0,
          pattern: patterns.N4_9,
          message: 'Weight must be greater than 0 and less than 9 characters including 4 decimal places.'
        }
      },
      "lookup": null
  },
  {
      "field_map": "weight",
      "item_name": "PK.weights.weight",
      "title": "Weight",
      "hint_detail": "Gross weight per package.",
      "hint_panel" : "Enter the gross weight of this package.",
      "example": "1.08",
      "sequence": 9,
      "show_more": true,
      'numerical': true,
      'digits_limit': 9,
      'validation': {
        'pies65' : {
          min: 0,
          pattern: patterns.N4_9,
          message: 'Weight must be greater than 0 and less than 9 characters including 4 decimal places.'
        }
      },
      "lookup": null
  },
  {
      "field_map": "weight",
      "item_name": "BX.weights.weight",
      "title": "Weight",
      "hint_detail": "Gross weight per package.",
      "hint_panel" : "Enter the gross weight of this package.",
      "example": "1.08",
      "sequence": 9,
      "show_more": true,
      'numerical': true,
      'digits_limit': 9,
      'validation': {
        'pies65' : {
          min: 0,
          pattern: patterns.N4_9,
          message: 'Weight must be greater than 0 and less than 9 characters including 4 decimal places.'
        }
      },
      "lookup": null
  },
  {
      "field_map": "weight",
      "item_name": "CA.weights.weight",
      "title": "Weight",
      "hint_detail": "Gross weight per package.",
      "hint_panel" : "Enter the gross weight of this package.",
      "example": "1.08",
      "sequence": 9,
      "show_more": true,
      'numerical': true,
      'digits_limit': 9,
      'validation': {
        'pies65' : {
          min: 0,
          pattern: patterns.N4_9,
          message: 'Weight must be greater than 0 and less than 9 characters including 4 decimal places..'
        }
      },
      "lookup": null
  },
  {
      "field_map": "weight",
      "item_name": "PL.weights.weight",
      "title": "Weight",
      "hint_detail": "Gross weight per package.",
      "hint_panel" : "Enter the gross weight of this package.",
      "example": "1.08",
      "sequence": 9,
      "show_more": true,
      'numerical': true,
      'digits_limit': 9,
      'validation': {
        'pies65' : {
          min: 0,
          pattern: patterns.N4_9,
          message: 'Weight must be greater than 0 and less than 9 characters including 4 decimal places.'
        }
      },
      "lookup": null
  },
  {
      "field_map": "dimensionalWeight",
      "item_name": "EA.weights.dimensional_weight",
      "title": "Dimensional weight",
      "hint_detail": "Dimensional weight is a standard formula used throughout the air-freight industry that considers density when determining charges. Dimensional weight is determined by using the International Air Transportation Association volumetric standard. The calculations are then used to consider the amount of space your package will take up on an aircraft in relation to the actual weight of your package.",
      "hint_panel" : "Dimensional weight is a standard formula used throughout the air-freight industry that considers density when determining charges. Dimensional weight is determined by using the International Air Transportation Association volumetric standard. The calculations are then used to consider the amount of space your package will take up on an aircraft in relation to the actual weight of your package. Domestic ground and air shipping formula for Dimensional Weight is (Height x Width x Length) / 194.",
      "example": "0.9444",
      "sequence": 10,
      "show_more": true,
      'numerical': true,
      'digits_limit': 9,
      'validation': {
        'pies65' : {
          min: 0,
          pattern: patterns.N4_9,
          message: dimensionalWeightValidationText,
        }
      },
      "lookup": null
  },
  {
      "field_map": "dimensionalWeight",
      "item_name": "PK.weights.dimensional_weight",
      "title": "Dimensional weight",
      "hint_detail": "Dimensional weight is a standard formula used throughout the air-freight industry that considers density when determining charges. Dimensional weight is determined by using the International Air Transportation Association volumetric standard. The calculations are then used to consider the amount of space your package will take up on an aircraft in relation to the actual weight of your package.",
      "hint_panel" : "Dimensional weight is a standard formula used throughout the air-freight industry that considers density when determining charges. Dimensional weight is determined by using the International Air Transportation Association volumetric standard. The calculations are then used to consider the amount of space your package will take up on an aircraft in relation to the actual weight of your package. Domestic ground and air shipping formula for Dimensional Weight is (Height x Width x Length) / 194.",
      "example": "0.9444",
      "sequence": 10,
      "show_more": true,
      'numerical': true,
      'digits_limit': 9,
      'validation': {
        'pies65' : {
          min: 0,
          pattern: patterns.N4_9,
          message: dimensionalWeightValidationText,
        }
      },
      "lookup": null
  },
  {
      "field_map": "dimensionalWeight",
      "item_name": "BX.weights.dimensional_weight",
      "title": "Dimensional weight",
      "hint_detail": "Dimensional weight is a standard formula used throughout the air-freight industry that considers density when determining charges. Dimensional weight is determined by using the International Air Transportation Association volumetric standard. The calculations are then used to consider the amount of space your package will take up on an aircraft in relation to the actual weight of your package.",
      "hint_panel" : "Dimensional weight is a standard formula used throughout the air-freight industry that considers density when determining charges. Dimensional weight is determined by using the International Air Transportation Association volumetric standard. The calculations are then used to consider the amount of space your package will take up on an aircraft in relation to the actual weight of your package. Domestic ground and air shipping formula for Dimensional Weight is (Height x Width x Length) / 194.",
      "example": "0.9444",
      "sequence": 10,
      "show_more": true,
      'numerical': true,
      'digits_limit': 9,
      'validation': {
        'pies65' : {
          min: 0,
          pattern: patterns.N4_9,
          message: dimensionalWeightValidationText,
        }
      },
      "lookup": null
  },
  {
      "field_map": "dimensionalWeight",
      "item_name": "CA.weights.dimensional_weight",
      "title": "Dimensional weight",
      "hint_detail": "Dimensional weight is a standard formula used throughout the air-freight industry that considers density when determining charges. Dimensional weight is determined by using the International Air Transportation Association volumetric standard. The calculations are then used to consider the amount of space your package will take up on an aircraft in relation to the actual weight of your package.",
      "hint_panel" : "Dimensional weight is a standard formula used throughout the air-freight industry that considers density when determining charges. Dimensional weight is determined by using the International Air Transportation Association volumetric standard. The calculations are then used to consider the amount of space your package will take up on an aircraft in relation to the actual weight of your package. Domestic ground and air shipping formula for Dimensional Weight is (Height x Width x Length) / 194.",
      "example": "0.9444",
      "sequence": 10,
      "show_more": true,
      'numerical': true,
      'digits_limit': 9,
      'validation': {
        'pies65' : {
          min: 0,
          pattern: patterns.N4_9,
          message: dimensionalWeightValidationText,
        }
      },
      "lookup": null
  },
  {
      "field_map": "dimensionalWeight",
      "item_name": "PL.weights.dimensional_weight",
      "title": "Dimensional weight",
      "hint_detail": "Dimensional weight is a standard formula used throughout the air-freight industry that considers density when determining charges. Dimensional weight is determined by using the International Air Transportation Association volumetric standard. The calculations are then used to consider the amount of space your package will take up on an aircraft in relation to the actual weight of your package.",
      "hint_panel" : "Dimensional weight is a standard formula used throughout the air-freight industry that considers density when determining charges. Dimensional weight is determined by using the International Air Transportation Association volumetric standard. The calculations are then used to consider the amount of space your package will take up on an aircraft in relation to the actual weight of your package. Domestic ground and air shipping formula for Dimensional Weight is (Height x Width x Length) / 194.",
      "example": "0.9444",
      "sequence": 10,
      "show_more": true,
      'numerical': true,
      'digits_limit': 9,
      'validation': {
        'pies65' : {
          min: 0,
          pattern: patterns.N4_9,
          message: dimensionalWeightValidationText,
        }
      },
      "lookup": null
  },
  {
      "field_map": "weightUom",
      "item_name": "EA.weights.uom",
      "title": "Weights unit measurement",
      "hint_detail": "Units of measurement for package weight. Gross pounds and gross kilograms are the only two options.",
      "hint_panel" : "Choose gross pounds or kilograms as the unit of measurement for package weight. These are the only two available options.",
      "example": "gross pounds",
      "sequence": 11,
      "show_more": true,
      'validation': {
        'pies65' : {
          required: true,
          message: 'Weights unit measurement is required.'
        }
      },
      "lookup": [
        {
          "option": "",
          "title": "-"
        },
        {
          "option": "PG",
          "title": "lbs"
        },
        {
          "option": "GT",
          "title": "kg"
        }
      ]
  },
  {
      "field_map": "weightUom",
      "item_name": "PK.weights.uom",
      "title": "Weights unit measurement",
      "hint_detail": "Units of measurement for package weight. Gross pounds and gross kilograms are the only two options.",
      "hint_panel" : "Choose gross pounds or kilograms as the unit of measurement for package weight. These are the only two available options.",
      "example": "gross pounds",
      "sequence": 11,
      "show_more": true,
      'validation': {
        'pies65' : {
          required: true,
          message: 'Weights unit measurement is required.'
        }
      },
      "lookup": [
        {
          "option": "",
          "title": "-"
        },
        {
          "option": "PG",
          "title": "lbs"
        },
        {
          "option": "GT",
          "title": "kg"
        }
      ]
  },
  {
      "field_map": "weightUom",
      "item_name": "BX.weights.uom",
      "title": "Weights unit measurement",
      "hint_detail": "Units of measurement for package weight. Gross pounds and gross kilograms are the only two options.",
      "hint_panel" : "Choose gross pounds or kilograms as the unit of measurement for package weight. These are the only two available options.",
      "example": "gross pounds",
      "sequence": 11,
      "show_more": true,
      'validation': {
        'pies65' : {
          required: true,
          message: 'Weights unit measurement is required.'
        }
      },
      "lookup": [
        {
          "option": "",
          "title": "-"
        },
        {
          "option": "PG",
          "title": "lbs"
        },
        {
          "option": "GT",
          "title": "kg"
        }
      ]
  },
  {
      "field_map": "weightUom",
      "item_name": "CA.weights.uom",
      "title": "Weights unit measurement",
      "hint_detail": "Units of measurement for package weight. Gross pounds and gross kilograms are the only two options.",
      "hint_panel" : "Choose gross pounds or kilograms as the unit of measurement for package weight. These are the only two available options.",
      "example": "gross pounds",
      "sequence": 11,
      "show_more": true,
      'validation': {
        'pies65' : {
          required: true,
          message: 'Weights unit measurement is required.'
        }
      },
      "lookup": [
        {
          "option": "",
          "title": "-"
        },
        {
          "option": "PG",
          "title": "lbs"
        },
        {
          "option": "GT",
          "title": "kg"
        }
      ]
  },
  {
      "field_map": "weightUom",
      "item_name": "PL.weights.uom",
      "title": "Weights unit measurement",
      "hint_detail": "Units of measurement for package weight. Gross pounds and gross kilograms are the only two options.",
      "hint_panel" : "Choose gross pounds or kilograms as the unit of measurement for package weight. These are the only two available options.",
      "example": "gross pounds",
      "sequence": 11,
      "show_more": true,
      'validation': {
        'pies65' : {
          required: true,
          message: 'Weights unit measurement is required.'
        }
      },
      "lookup": [
        {
          "option": "",
          "title": "-"
        },
        {
          "option": "PG",
          "title": "lbs"
        },
        {
          "option": "GT",
          "title": "kg"
        }
      ]
  },
  {
      "field_map": "packageLevelGtin",
      "item_name": "EA.package_level_GTIN",
      "title": "Package GTIN",
      "hint_detail": "Global Trade Identification Number (GTIN) in GTIN-14 format (Pack Level | Vendor | Item Num | Check Digit). ",
      "hint_panel" : "This field is coded as a Numeric (N) value, as all characters in the GTIN should be numeric. WARNING: Programs such as Microsoft Excel will drop leading zeros if the field is not formatted as text. To avoid confusion using this field, the range has been omitted and the field is now fixed at 14 characters, INCLUDING leading zeros where necessary.",
      "example": "00055544001627",
      "sequence": 12,
      "show_more": true,
      'numerical': true,
      'validation': {
        'pies65' : {
          length: 14,
          'custom': function (): ValidatorFn {
            return gtinValidation();
          },
          message: 'Package GTIN must be 14 characters.'
        }
      },
      "lookup": null
  },
  {
      "field_map": "packageLevelGtin",
      "item_name": "PK.package_level_GTIN",
      "title": "Package GTIN",
      "hint_detail": "Global Trade Identification Number (GTIN) in GTIN-14 format (Pack Level | Vendor | Item Num | Check Digit). ",
      "hint_panel" : "This field is coded as a Numeric (N) value, as all characters in the GTIN should be numeric. WARNING: Programs such as Microsoft Excel will drop leading zeros if the field is not formatted as text. To avoid confusion using this field, the range has been omitted and the field is now fixed at 14 characters, INCLUDING leading zeros where necessary.",
      "example": "00055544001627",
      "sequence": 12,
      "show_more": true,
      'numerical': true,
      'validation': {
        'pies65' : {
          length: 14,
          'custom': function (): ValidatorFn {
            return gtinValidation();
          },
          message: 'Package GTIN must be 14 characters.'
        }
      },
      "lookup": null
  },
  {
      "field_map": "packageLevelGtin",
      "item_name": "BX.package_level_GTIN",
      "title": "Package GTIN",
      "hint_detail": "Global Trade Identification Number (GTIN) in GTIN-14 format (Pack Level | Vendor | Item Num | Check Digit). ",
      "hint_panel" : "This field is coded as a Numeric (N) value, as all characters in the GTIN should be numeric. WARNING: Programs such as Microsoft Excel will drop leading zeros if the field is not formatted as text. To avoid confusion using this field, the range has been omitted and the field is now fixed at 14 characters, INCLUDING leading zeros where necessary.",
      "example": "00055544001627",
      "sequence": 12,
      "show_more": true,
      'numerical': true,
      'validation': {
        'pies65' : {
          length: 14,
          'custom': function (): ValidatorFn {
            return gtinValidation();
          },
          message: 'Package GTIN must be 14 characters.'
        }
      },
      "lookup": null
  },
  {
      "field_map": "packageLevelGtin",
      "item_name": "CA.package_level_GTIN",
      "title": "Package GTIN",
      "hint_detail": "Global Trade Identification Number (GTIN) in GTIN-14 format (Pack Level | Vendor | Item Num | Check Digit). ",
      "hint_panel" : "This field is coded as a Numeric (N) value, as all characters in the GTIN should be numeric. WARNING: Programs such as Microsoft Excel will drop leading zeros if the field is not formatted as text. To avoid confusion using this field, the range has been omitted and the field is now fixed at 14 characters, INCLUDING leading zeros where necessary.",
      "example": "00055544001627",
      "sequence": 12,
      "show_more": true,
      'numerical': true,
      'validation': {
        'pies65' : {
          length: 14,
          'custom': function (): ValidatorFn {
            return gtinValidation();
          },
          message: 'Package GTIN must be 14 characters.'
        }
      },
      "lookup": null
  },
  {
      "field_map": "packageLevelGtin",
      "item_name": "PL.package_level_GTIN",
      "title": "Package GTIN",
      "hint_detail": "Global Trade Identification Number (GTIN) in GTIN-14 format (Pack Level | Vendor | Item Num | Check Digit). ",
      "hint_panel" : "This field is coded as a Numeric (N) value, as all characters in the GTIN should be numeric. WARNING: Programs such as Microsoft Excel will drop leading zeros if the field is not formatted as text. To avoid confusion using this field, the range has been omitted and the field is now fixed at 14 characters, INCLUDING leading zeros where necessary.",
      "example": "00055544001627",
      "sequence": 12,
      "show_more": true,
      'numerical': true,
      'validation': {
        'pies65' : {
          length: 14,
          'custom': function (): ValidatorFn {
            return gtinValidation();
          },
          message: 'Package GTIN must be 14 characters.'
        }
      },
      "lookup": null
  },
  {
      "field_map": "stackingFactor",
      "item_name": "EA.stacking_factor",
      "title": "Stacking factor",
      "hint_detail": "Number of layers of package level which can be safely stacked on top of each other. Applicable to each packaging option.",
      "hint_panel" : "Enter how many layers of package level which can be safely stacked on top of each other. Applicable to each packaging option.",
      "example": "Eaches may be 5. Cases may be 3. Pallets may be 1.",
      "sequence": 12,
      "show_more": true,
      'numerical': true,
      'validation': {
        'pies65' : {
          minLength: 0,
          maxLength: 3,
          message: 'Stacking factor must be greater than 0.'
        }
      },
      "lookup": null
  },
  {
      "field_map": "stackingFactor",
      "item_name": "PK.stacking_factor",
      "title": "Stacking factor",
      "hint_detail": "Number of layers of package level which can be safely stacked on top of each other. Applicable to each packaging option.",
      "hint_panel" : "Enter how many layers of package level which can be safely stacked on top of each other. Applicable to each packaging option.",
      "example": "Eaches may be 5. Cases may be 3. Pallets may be 1.",
      "sequence": 12,
      "show_more": true,
      'numerical': true,
      'validation': {
        'pies65' : {
          minLength: 0,
          maxLength: 3,
          message: 'Stacking factor must be greater than 0.'
        }
      },
      "lookup": null
  },
  {
      "field_map": "stackingFactor",
      "item_name": "BX.stacking_factor",
      "title": "Stacking factor",
      "hint_detail": "Number of layers of package level which can be safely stacked on top of each other. Applicable to each packaging option.",
      "hint_panel" : "Enter how many layers of package level which can be safely stacked on top of each other. Applicable to each packaging option.",
      "example": "Eaches may be 5. Cases may be 3. Pallets may be 1.",
      "sequence": 12,
      "show_more": true,
      'numerical': true,
      'validation': {
        'pies65' : {
          minLength: 0,
          maxLength: 3,
          message: 'Stacking factor must be greater than 0.'
        }
      },
      "lookup": null
  },
  {
      "field_map": "stackingFactor",
      "item_name": "CA.stacking_factor",
      "title": "Stacking factor",
      "hint_detail": "Number of layers of package level which can be safely stacked on top of each other. Applicable to each packaging option.",
      "hint_panel" : "Enter how many layers of package level which can be safely stacked on top of each other. Applicable to each packaging option.",
      "example": "Eaches may be 5. Cases may be 3. Pallets may be 1.",
      "sequence": 12,
      "show_more": true,
      'numerical': true,
      'validation': {
        'pies65' : {
          minLength: 0,
          maxLength: 3,
          message: 'Stacking factor must be greater than 0.'
        }
      },
      "lookup": null
  },
  {
      "field_map": "stackingFactor",
      "item_name": "PL.stacking_factor",
      "title": "Stacking factor",
      "hint_detail": "Number of layers of package level which can be safely stacked on top of each other. Applicable to each packaging option.",
      "hint_panel" : "Enter how many layers of package level which can be safely stacked on top of each other. Applicable to each packaging option.",
      "example": "Eaches may be 5. Cases may be 3. Pallets may be 1.",
      "sequence": 12,
      "show_more": true,
      'numerical': true,
      'validation': {
        'pies65' : {
          minLength: 0,
          maxLength: 3,
          message: 'Stacking factor must be greater than 0.'
        }
      },
      "lookup": null
  },
  {
      "field_map": "packageBarCodeCharacters",
      "item_name": "EA.package_bar_code_characters",
      "title": "Bar code",
      "hint_detail": "Use if package bar code characters are different from GTIN.",
      "hint_panel" : "Use if package bar code characters are different from GTIN.",
      "example": "055544001628",
      "sequence": 13,
      "show_more": true,
      'validation': {
        'pies65' : {
          minLength: 1,
          maxLength: 48,
          pattern: patterns.ANbarCode,
          message: 'Bar code must be less than 49 characters.'
        }
      },
      "lookup": null
  },
  {
      "field_map": "packageBarCodeCharacters",
      "item_name": "PK.package_bar_code_characters",
      "title": "Bar code",
      "hint_detail": "Use if package bar code characters are different from GTIN.",
      "hint_panel" : "Use if package bar code characters are different from GTIN.",
      "example": "055544001628",
      "sequence": 13,
      "show_more": true,
      'validation': {
        'pies65' : {
          minLength: 1,
          maxLength: 48,
          pattern: patterns.ANbarCode,
          message: 'Bar code must be less than 49 characters.'
        }
      },
      "lookup": null
  },
  {
      "field_map": "packageBarCodeCharacters",
      "item_name": "BX.package_bar_code_characters",
      "title": "Bar code",
      "hint_detail": "Use if package bar code characters are different from GTIN.",
      "hint_panel" : "Use if package bar code characters are different from GTIN.",
      "example": "055544001628",
      "sequence": 13,
      "show_more": true,
      'validation': {
        'pies65' : {
          minLength: 1,
          maxLength: 48,
          pattern: patterns.ANbarCode,
          message: 'Bar code must be less than 49 characters.'
        }
      },
      "lookup": null
  },
  {
      "field_map": "packageBarCodeCharacters",
      "item_name": "CA.package_bar_code_characters",
      "title": "Bar code",
      "hint_detail": "Use if package bar code characters are different from GTIN.",
      "hint_panel" : "Use if package bar code characters are different from GTIN.",
      "example": "055544001628",
      "sequence": 13,
      "show_more": true,
      'validation': {
        'pies65' : {
          minLength: 1,
          maxLength: 48,
          pattern: patterns.ANbarCode,
          message: 'Bar code must be less than 49 characters.'
        }
      },
      "lookup": null
  },
  {
      "field_map": "packageBarCodeCharacters",
      "item_name": "PL.package_bar_code_characters",
      "title": "Bar code",
      "hint_detail": "Use if package bar code characters are different from GTIN.",
      "hint_panel" : "Use if package bar code characters are different from GTIN.",
      "example": "055544001628",
      "sequence": 13,
      "show_more": true,
      'validation': {
        'pies65' : {
          minLength: 1,
          maxLength: 48,
          pattern: patterns.ANbarCode,
          message: 'Bar code must be less than 49 characters.'
        }
      },
      "lookup": null
  },
  {
      "field_map": "electronicProductCode",
      "item_name": "EA.electronic_product_code",
      "title": "Electronic code",
      "hint_detail": "Written form of RFID code (electronic barcode).",
      "hint_panel" : "Written form of RFID code (electronic barcode). For reference visit www.epcglobalinc.org/standards",
      "example": "055544001628",
      "sequence": 14,
      "show_more": true,
      'validation': {
        'pies65' : {
          length: 27,
          message: 'Electronic code must be exactly 27 characters.'
        }
      },
      "lookup": null
  },
  {
      "field_map": "electronicProductCode",
      "item_name": "PK.electronic_product_code",
      "title": "Electronic code",
      "hint_detail": "Written form of RFID code (electronic barcode).",
      "hint_panel" : "Written form of RFID code (electronic barcode). For reference visit www.epcglobalinc.org/standards",
      "example": "055544001628",
      "sequence": 14,
      "show_more": true,
      'validation': {
        'pies65' : {
          length: 27,
          message: 'Electronic code must be exactly 27 characters.'
        }
      },
      "lookup": null
  },
  {
      "field_map": "electronicProductCode",
      "item_name": "BX.electronic_product_code",
      "title": "Electronic code",
      "hint_detail": "Written form of RFID code (electronic barcode).",
      "hint_panel" : "Written form of RFID code (electronic barcode). For reference visit www.epcglobalinc.org/standards",
      "example": "055544001628",
      "sequence": 14,
      "show_more": true,
      'validation': {
        'pies65' : {
          length: 27,
          message: 'Electronic code must be exactly 27 characters.'
        }
      },
      "lookup": null
  },
  {
      "field_map": "electronicProductCode",
      "item_name": "CA.electronic_product_code",
      "title": "Electronic code",
      "hint_detail": "Written form of RFID code (electronic barcode).",
      "hint_panel" : "Written form of RFID code (electronic barcode). For reference visit www.epcglobalinc.org/standards",
      "example": "055544001628",
      "sequence": 14,
      "show_more": true,
      'validation': {
        'pies65' : {
          length: 27,
          message: 'Electronic code must be exactly 27 characters.'
        }
      },
      "lookup": null
  },
  {
      "field_map": "electronicProductCode",
      "item_name": "PL.electronic_product_code",
      "title": "Electronic code",
      "hint_detail": "Written form of RFID code (electronic barcode).",
      "hint_panel" : "Written form of RFID code (electronic barcode). For reference visit www.epcglobalinc.org/standards",
      "example": "055544001628",
      "sequence": 14,
      "show_more": true,
      'validation': {
        'pies65' : {
          length: 27,
          message: 'Electronic code must be exactly 27 characters.'
        }
      },
      "lookup": null
  },
  {
      "field_map": "innerQuantity",
      "item_name": "EA.inner_quantity",
      "title": "Inner quantity",
      "hint_detail": "Inner quantity of items within this package.",
      "hint_panel" : "Enter the inner quantity of items in this package type.",
      "example": "1",
      "sequence": 15,
      "show_more": true,
      'numerical': true,
      'validation': {
        'pies65' : {
          min: 0,
          pattern: patterns.R1_8,
          message: 'Inner quantity must be greater than 0.'
        }
      },
      "lookup": null
  },
  {
      "field_map": "innerQuantity",
      "item_name": "PK.inner_quantity",
      "title": "Inner quantity",
      "hint_detail": "Inner quantity of items within this package.",
      "hint_panel" : "Enter the inner quantity of items in this package type.",
      "example": "2",
      "sequence": 15,
      "show_more": true,
      'numerical': true,
      'validation': {
        'pies65' : {
          min: 0,
          pattern: patterns.R1_8,
          message: 'Inner quantity must be greater than 0.'
        }
      },
      "lookup": null
  },
  {
      "field_map": "innerQuantity",
      "item_name": "BX.inner_quantity",
      "title": "Inner quantity",
      "hint_detail": "Inner quantity of items within this package.",
      "hint_panel" : "Enter the inner quantity of items in this package type.",
      "example": "5",
      "sequence": 15,
      "show_more": true,
      'numerical': true,
      'validation': {
        'pies65' : {
          min: 0,
          pattern: patterns.R1_8,
          message: 'Inner quantity must be greater than 0.'
        }
      },
      "lookup": null
  },
  {
      "field_map": "innerQuantity",
      "item_name": "CA.inner_quantity",
      "title": "Inner quantity",
      "hint_detail": "Inner quantity of items within this package.",
      "hint_panel" : "Enter the inner quantity of items in this package type.",
      "example": "30",
      "sequence": 15,
      "show_more": true,
      'numerical': true,
      'validation': {
        'pies65' : {
          min: 0,
          pattern: patterns.R1_8,
          message: 'Inner quantity must be greater than 0.'
        }
      },
      "lookup": null
  },
  {
      "field_map": "innerQuantity",
      "item_name": "PL.inner_quantity",
      "title": "Inner quantity",
      "hint_detail": "Inner quantity of items within this package.",
      "hint_panel" : "Enter the inner quantity of items in this package type.",
      "example": "120",
      "sequence": 15,
      "show_more": true,
      'numerical': true,
      'validation': {
        'pies65' : {
          min: 0,
          pattern: patterns.R1_8,
          message: 'Inner quantity must be greater than 0.'
        }
      },
      "lookup": null
  },
  {
      "field_map": "innerQuantityUom",
      "item_name": "EA.inner_quantity_uom",
      "title": "Inner quantity unit measurement",
      "hint_detail": "Unit of measure for the inner quantity.",
      "hint_panel" : "Enter the unit of measure for the inner quantity.",
      "example": "Each",
      "sequence": 16,
      "show_more": true,
      "lookup": [
        { 'option': '', 'title': '-' },
        { 'option': 'OZ', 'title': 'Ounces' },
        { 'option': 'AS', 'title': 'Assortment' },
        { 'option': 'BG', 'title': 'Bag' },
        { 'option': 'BK', 'title': 'Book' },
        { 'option': 'BO', 'title': 'Bottle' },
        { 'option': 'BX', 'title': 'Box' },
        { 'option': 'BC', 'title': 'Bucket' },
        { 'option': 'BD', 'title': 'Bundle' },
        { 'option': 'CN', 'title': 'Can' },
        { 'option': 'CG', 'title': 'Card' },
        { 'option': 'CT', 'title': 'Carton' },
        { 'option': 'CQ', 'title': 'Cartridge' },
        { 'option': 'CA', 'title': 'Case' },
        { 'option': 'CX', 'title': 'Coil' },
        { 'option': 'CH', 'title': 'Container' },
        { 'option': 'FN', 'title': 'Clamshell' },
        { 'option': 'CP', 'title': 'Crate' },
        { 'option': 'DZ', 'title': 'Dozen' },
        { 'option': 'DR', 'title': 'Drum' },
        { 'option': 'EA', 'title': 'Each' },
        { 'option': 'EV', 'title': 'Envelope' },
        { 'option': 'FT', 'title': 'Foot' },
        { 'option': 'GA', 'title': 'Gallon' },
        { 'option': 'HU', 'title': 'Hundred' },
        { 'option': 'HC', 'title': 'Hundred count' },
        { 'option': 'JR', 'title': 'Jar' },
        { 'option': 'KE', 'title': 'Keg' },
        { 'option': 'KG', 'title': 'Kilogram' },
        { 'option': 'KT', 'title': 'Kit' },
        { 'option': 'LT', 'title': 'Liter' },
        { 'option': 'MR', 'title': 'Meter' },
        { 'option': 'PH', 'title': 'Pack (PAK)' },
        { 'option': 'PK', 'title': 'Package' },
        { 'option': 'PA', 'title': 'Pail' },
        { 'option': 'PR', 'title': 'Pair' },
        { 'option': 'PF', 'title': 'Pallet' },
        { 'option': 'PL', 'title': 'Pallet unit load' },
        { 'option': 'PC', 'title': 'Piece' },
        { 'option': 'PT', 'title': 'Pint' },
        { 'option': 'LB', 'title': 'Pound' },
        { 'option': 'QT', 'title': 'Quart' },
        { 'option': 'RE', 'title': 'Reel' },
        { 'option': 'RD', 'title': 'Rod' },
        { 'option': 'RL', 'title': 'Roll' },
        { 'option': 'ST', 'title': 'Set' },
        { 'option': 'SH', 'title': 'Sheet' },
        { 'option': 'SL', 'title': 'Sleeve' },
        { 'option': 'SO', 'title': 'Spool' },
        { 'option': '15', 'title': 'Stick' },
        { 'option': 'TH', 'title': 'Thousand' },
        { 'option': 'TY', 'title': 'Tray' },
        { 'option': 'TB', 'title': 'Tube' },
        { 'option': 'OP', 'title': 'Two pack' },
    ]
  },
  {
      "field_map": "innerQuantityUom",
      "item_name": "PK.inner_quantity_uom",
      "title": "Inner quantity unit measurement",
      "hint_detail": "Unit of measure for the inner quantity.",
      "hint_panel" : "Enter the unit of measure for the inner quantity.",
      "example": "Each",
      "sequence": 16,
      "show_more": true,
      "lookup": [
        { 'option': '', 'title': '-' },
        { 'option': 'OZ', 'title': 'Ounces' },
        { 'option': 'AS', 'title': 'Assortment' },
        { 'option': 'BG', 'title': 'Bag' },
        { 'option': 'BK', 'title': 'Book' },
        { 'option': 'BO', 'title': 'Bottle' },
        { 'option': 'BX', 'title': 'Box' },
        { 'option': 'BC', 'title': 'Bucket' },
        { 'option': 'BD', 'title': 'Bundle' },
        { 'option': 'CN', 'title': 'Can' },
        { 'option': 'CG', 'title': 'Card' },
        { 'option': 'CT', 'title': 'Carton' },
        { 'option': 'CQ', 'title': 'Cartridge' },
        { 'option': 'CA', 'title': 'Case' },
        { 'option': 'CX', 'title': 'Coil' },
        { 'option': 'CH', 'title': 'Container' },
        { 'option': 'FN', 'title': 'Clamshell' },
        { 'option': 'CP', 'title': 'Crate' },
        { 'option': 'DZ', 'title': 'Dozen' },
        { 'option': 'DR', 'title': 'Drum' },
        { 'option': 'EA', 'title': 'Each' },
        { 'option': 'EV', 'title': 'Envelope' },
        { 'option': 'FT', 'title': 'Foot' },
        { 'option': 'GA', 'title': 'Gallon' },
        { 'option': 'HU', 'title': 'Hundred' },
        { 'option': 'HC', 'title': 'Hundred count' },
        { 'option': 'JR', 'title': 'Jar' },
        { 'option': 'KE', 'title': 'Keg' },
        { 'option': 'KG', 'title': 'Kilogram' },
        { 'option': 'KT', 'title': 'Kit' },
        { 'option': 'LT', 'title': 'Liter' },
        { 'option': 'MR', 'title': 'Meter' },
        { 'option': 'PH', 'title': 'Pack (PAK)' },
        { 'option': 'PK', 'title': 'Package' },
        { 'option': 'PA', 'title': 'Pail' },
        { 'option': 'PR', 'title': 'Pair' },
        { 'option': 'PF', 'title': 'Pallet' },
        { 'option': 'PL', 'title': 'Pallet unit load' },
        { 'option': 'PC', 'title': 'Piece' },
        { 'option': 'PT', 'title': 'Pint' },
        { 'option': 'LB', 'title': 'Pound' },
        { 'option': 'QT', 'title': 'Quart' },
        { 'option': 'RE', 'title': 'Reel' },
        { 'option': 'RD', 'title': 'Rod' },
        { 'option': 'RL', 'title': 'Roll' },
        { 'option': 'ST', 'title': 'Set' },
        { 'option': 'SH', 'title': 'Sheet' },
        { 'option': 'SL', 'title': 'Sleeve' },
        { 'option': 'SO', 'title': 'Spool' },
        { 'option': '15', 'title': 'Stick' },
        { 'option': 'TH', 'title': 'Thousand' },
        { 'option': 'TY', 'title': 'Tray' },
        { 'option': 'TB', 'title': 'Tube' },
        { 'option': 'OP', 'title': 'Two pack' },
    ]
  },
  {
      "field_map": "innerQuantityUom",
      "item_name": "BX.inner_quantity_uom",
      "title": "Inner quantity unit measurement",
      "hint_detail": "Unit of measure for the inner quantity.",
      "hint_panel" : "Enter the unit of measure for the inner quantity.",
      "example": "Each",
      "sequence": 16,
      "show_more": true,
      "lookup": [
        { 'option': '', 'title': '-' },
        { 'option': 'OZ', 'title': 'Ounces' },
        { 'option': 'AS', 'title': 'Assortment' },
        { 'option': 'BG', 'title': 'Bag' },
        { 'option': 'BK', 'title': 'Book' },
        { 'option': 'BO', 'title': 'Bottle' },
        { 'option': 'BX', 'title': 'Box' },
        { 'option': 'BC', 'title': 'Bucket' },
        { 'option': 'BD', 'title': 'Bundle' },
        { 'option': 'CN', 'title': 'Can' },
        { 'option': 'CG', 'title': 'Card' },
        { 'option': 'CT', 'title': 'Carton' },
        { 'option': 'CQ', 'title': 'Cartridge' },
        { 'option': 'CA', 'title': 'Case' },
        { 'option': 'CX', 'title': 'Coil' },
        { 'option': 'CH', 'title': 'Container' },
        { 'option': 'FN', 'title': 'Clamshell' },
        { 'option': 'CP', 'title': 'Crate' },
        { 'option': 'DZ', 'title': 'Dozen' },
        { 'option': 'DR', 'title': 'Drum' },
        { 'option': 'EA', 'title': 'Each' },
        { 'option': 'EV', 'title': 'Envelope' },
        { 'option': 'FT', 'title': 'Foot' },
        { 'option': 'GA', 'title': 'Gallon' },
        { 'option': 'HU', 'title': 'Hundred' },
        { 'option': 'HC', 'title': 'Hundred count' },
        { 'option': 'JR', 'title': 'Jar' },
        { 'option': 'KE', 'title': 'Keg' },
        { 'option': 'KG', 'title': 'Kilogram' },
        { 'option': 'KT', 'title': 'Kit' },
        { 'option': 'LT', 'title': 'Liter' },
        { 'option': 'MR', 'title': 'Meter' },
        { 'option': 'PH', 'title': 'Pack (PAK)' },
        { 'option': 'PK', 'title': 'Package' },
        { 'option': 'PA', 'title': 'Pail' },
        { 'option': 'PR', 'title': 'Pair' },
        { 'option': 'PF', 'title': 'Pallet' },
        { 'option': 'PL', 'title': 'Pallet unit load' },
        { 'option': 'PC', 'title': 'Piece' },
        { 'option': 'PT', 'title': 'Pint' },
        { 'option': 'LB', 'title': 'Pound' },
        { 'option': 'QT', 'title': 'Quart' },
        { 'option': 'RE', 'title': 'Reel' },
        { 'option': 'RD', 'title': 'Rod' },
        { 'option': 'RL', 'title': 'Roll' },
        { 'option': 'ST', 'title': 'Set' },
        { 'option': 'SH', 'title': 'Sheet' },
        { 'option': 'SL', 'title': 'Sleeve' },
        { 'option': 'SO', 'title': 'Spool' },
        { 'option': '15', 'title': 'Stick' },
        { 'option': 'TH', 'title': 'Thousand' },
        { 'option': 'TY', 'title': 'Tray' },
        { 'option': 'TB', 'title': 'Tube' },
        { 'option': 'OP', 'title': 'Two pack' },
    ]
  },
  {
      "field_map": "innerQuantityUom",
      "item_name": "CA.inner_quantity_uom",
      "title": "Inner quantity unit measurement",
      "hint_detail": "Unit of measure for the inner quantity.",
      "hint_panel" : "Enter the unit of measure for the inner quantity.",
      "example": "Each",
      "sequence": 16,
      "show_more": true,
      "lookup": [
        { 'option': '', 'title': '-' },
        { 'option': 'OZ', 'title': 'Ounces' },
        { 'option': 'AS', 'title': 'Assortment' },
        { 'option': 'BG', 'title': 'Bag' },
        { 'option': 'BK', 'title': 'Book' },
        { 'option': 'BO', 'title': 'Bottle' },
        { 'option': 'BX', 'title': 'Box' },
        { 'option': 'BC', 'title': 'Bucket' },
        { 'option': 'BD', 'title': 'Bundle' },
        { 'option': 'CN', 'title': 'Can' },
        { 'option': 'CG', 'title': 'Card' },
        { 'option': 'CT', 'title': 'Carton' },
        { 'option': 'CQ', 'title': 'Cartridge' },
        { 'option': 'CA', 'title': 'Case' },
        { 'option': 'CX', 'title': 'Coil' },
        { 'option': 'CH', 'title': 'Container' },
        { 'option': 'FN', 'title': 'Clamshell' },
        { 'option': 'CP', 'title': 'Crate' },
        { 'option': 'DZ', 'title': 'Dozen' },
        { 'option': 'DR', 'title': 'Drum' },
        { 'option': 'EA', 'title': 'Each' },
        { 'option': 'EV', 'title': 'Envelope' },
        { 'option': 'FT', 'title': 'Foot' },
        { 'option': 'GA', 'title': 'Gallon' },
        { 'option': 'HU', 'title': 'Hundred' },
        { 'option': 'HC', 'title': 'Hundred count' },
        { 'option': 'JR', 'title': 'Jar' },
        { 'option': 'KE', 'title': 'Keg' },
        { 'option': 'KG', 'title': 'Kilogram' },
        { 'option': 'KT', 'title': 'Kit' },
        { 'option': 'LT', 'title': 'Liter' },
        { 'option': 'MR', 'title': 'Meter' },
        { 'option': 'PH', 'title': 'Pack (PAK)' },
        { 'option': 'PK', 'title': 'Package' },
        { 'option': 'PA', 'title': 'Pail' },
        { 'option': 'PR', 'title': 'Pair' },
        { 'option': 'PF', 'title': 'Pallet' },
        { 'option': 'PL', 'title': 'Pallet unit load' },
        { 'option': 'PC', 'title': 'Piece' },
        { 'option': 'PT', 'title': 'Pint' },
        { 'option': 'LB', 'title': 'Pound' },
        { 'option': 'QT', 'title': 'Quart' },
        { 'option': 'RE', 'title': 'Reel' },
        { 'option': 'RD', 'title': 'Rod' },
        { 'option': 'RL', 'title': 'Roll' },
        { 'option': 'ST', 'title': 'Set' },
        { 'option': 'SH', 'title': 'Sheet' },
        { 'option': 'SL', 'title': 'Sleeve' },
        { 'option': 'SO', 'title': 'Spool' },
        { 'option': '15', 'title': 'Stick' },
        { 'option': 'TH', 'title': 'Thousand' },
        { 'option': 'TY', 'title': 'Tray' },
        { 'option': 'TB', 'title': 'Tube' },
        { 'option': 'OP', 'title': 'Two pack' },
    ]
  },
  {
      "field_map": "innerQuantityUom",
      "item_name": "PL.inner_quantity_uom",
      "title": "Inner quantity unit measurement",
      "hint_detail": "Unit of measure for the inner quantity.",
      "hint_panel" : "Enter the unit of measure for the inner quantity.",
      "example": "Each",
      "sequence": 16,
      "show_more": true,
      "lookup": [
        { 'option': '', 'title': '-' },
        { 'option': 'OZ', 'title': 'Ounces' },
        { 'option': 'AS', 'title': 'Assortment' },
        { 'option': 'BG', 'title': 'Bag' },
        { 'option': 'BK', 'title': 'Book' },
        { 'option': 'BO', 'title': 'Bottle' },
        { 'option': 'BX', 'title': 'Box' },
        { 'option': 'BC', 'title': 'Bucket' },
        { 'option': 'BD', 'title': 'Bundle' },
        { 'option': 'CN', 'title': 'Can' },
        { 'option': 'CG', 'title': 'Card' },
        { 'option': 'CT', 'title': 'Carton' },
        { 'option': 'CQ', 'title': 'Cartridge' },
        { 'option': 'CA', 'title': 'Case' },
        { 'option': 'CX', 'title': 'Coil' },
        { 'option': 'CH', 'title': 'Container' },
        { 'option': 'FN', 'title': 'Clamshell' },
        { 'option': 'CP', 'title': 'Crate' },
        { 'option': 'DZ', 'title': 'Dozen' },
        { 'option': 'DR', 'title': 'Drum' },
        { 'option': 'EA', 'title': 'Each' },
        { 'option': 'EV', 'title': 'Envelope' },
        { 'option': 'FT', 'title': 'Foot' },
        { 'option': 'GA', 'title': 'Gallon' },
        { 'option': 'HU', 'title': 'Hundred' },
        { 'option': 'HC', 'title': 'Hundred count' },
        { 'option': 'JR', 'title': 'Jar' },
        { 'option': 'KE', 'title': 'Keg' },
        { 'option': 'KG', 'title': 'Kilogram' },
        { 'option': 'KT', 'title': 'Kit' },
        { 'option': 'LT', 'title': 'Liter' },
        { 'option': 'MR', 'title': 'Meter' },
        { 'option': 'PH', 'title': 'Pack (PAK)' },
        { 'option': 'PK', 'title': 'Package' },
        { 'option': 'PA', 'title': 'Pail' },
        { 'option': 'PR', 'title': 'Pair' },
        { 'option': 'PF', 'title': 'Pallet' },
        { 'option': 'PL', 'title': 'Pallet unit load' },
        { 'option': 'PC', 'title': 'Piece' },
        { 'option': 'PT', 'title': 'Pint' },
        { 'option': 'LB', 'title': 'Pound' },
        { 'option': 'QT', 'title': 'Quart' },
        { 'option': 'RE', 'title': 'Reel' },
        { 'option': 'RD', 'title': 'Rod' },
        { 'option': 'RL', 'title': 'Roll' },
        { 'option': 'ST', 'title': 'Set' },
        { 'option': 'SH', 'title': 'Sheet' },
        { 'option': 'SL', 'title': 'Sleeve' },
        { 'option': 'SO', 'title': 'Spool' },
        { 'option': '15', 'title': 'Stick' },
        { 'option': 'TH', 'title': 'Thousand' },
        { 'option': 'TY', 'title': 'Tray' },
        { 'option': 'TB', 'title': 'Tube' },
        { 'option': 'OP', 'title': 'Two pack' },
    ]
  },
  {
    "field_map": "languageCode",
    "item_name": "EA.hazardous_materials.0.language",
    'title': 'Language',
    'hint_detail': 'Language in which this description is written.',
    'hint_panel' : 'Choose the language which this description is written.',
    'example': 'English',
    'sequence': 5,
    'show_more': true,
    'lookup': [
      { 'option': '', 'title': '-' },
      {
        "option": "EN",
        "title": "English"
      },
      {
        "option": "ES",
        "title": "Spanish"
      },
      {
        "option": "FR",
        "title": "French"
      }
    ]
  },
  {
    "field_map": "languageCode",
    "item_name": "PK.hazardous_materials.0.language",
    'title': 'Language',
    'hint_detail': 'Language in which this description is written.',
    'hint_panel' : 'Choose the language which this description is written.',
    'example': 'English',
    'sequence': 5,
    'show_more': true,
    'lookup': [
      { 'option': '', 'title': '-' },
      {
        "option": "EN",
        "title": "English"
      },
      {
        "option": "ES",
        "title": "Spanish"
      },
      {
        "option": "FR",
        "title": "French"
      }
    ]
  },
  {
    "field_map": "languageCode",
    "item_name": "BX.hazardous_materials.0.language",
    'title': 'Language',
    'hint_detail': 'Language in which this description is written.',
    'hint_panel' : 'Choose the language which this description is written.',
    'example': 'English',
    'sequence': 5,
    'show_more': true,
    'lookup': [
      { 'option': '', 'title': '-' },
      {
        "option": "EN",
        "title": "English"
      },
      {
        "option": "ES",
        "title": "Spanish"
      },
      {
        "option": "FR",
        "title": "French"
      }
    ]
  },
  {
    "field_map": "languageCode",
    "item_name": "CA.hazardous_materials.0.language",
    'title': 'Language',
    'hint_detail': 'Language in which this description is written.',
    'hint_panel' : 'Choose the language which this description is written.',
    'example': 'English',
    'sequence': 5,
    'show_more': true,
    'lookup': [
      { 'option': '', 'title': '-' },
      {
        "option": "EN",
        "title": "English"
      },
      {
        "option": "ES",
        "title": "Spanish"
      },
      {
        "option": "FR",
        "title": "French"
      }
    ]
  },
  {
    "field_map": "languageCode",
    "item_name": "PL.hazardous_materials.0.language",
    'title': 'Language',
    'hint_detail': 'Language in which this description is written.',
    'hint_panel' : 'Choose the language which this description is written.',
    'example': 'English',
    'sequence': 5,
    'show_more': true,
    'lookup': [
      { 'option': '', 'title': '-' },
      {
        "option": "EN",
        "title": "English"
      },
      {
        "option": "ES",
        "title": "Spanish"
      },
      {
        "option": "FR",
        "title": "French"
      }
    ]
  },
  {
      "field_map": "shippingScope",
      "item_name": "EA.hazardous_materials.0.shipping_scope",
      "title": "Shipping scope",
      "hint_detail": "Indicates whether you (the source location) are shipping Domestically (DOM) or internationally (INT) <br>DOM = Domestic <br> INT = International",
      "hint_panel" : "Indicates whether you (the source location) are shipping Domestically (DOM) or internationally (INT) <br>DOM = Domestic <br> INT = International",
      "example": "Domestic",
      "sequence": 17,
      "show_more": true,
      "lookup": [
        { 'option': '', 'title': '-' },
        {
          'option': 'DOM',
          'title': 'Domestic'
        },
        {
          'option': 'INT',
          'title': 'International'
        },
      ]
  },
  {
      "field_map": "shippingScope",
      "item_name": "PK.hazardous_materials.0.shipping_scope",
      "title": "Shipping scope",
      "hint_detail": "Indicates whether you (the source location) are shipping Domestically (DOM) or internationally (INT) <br>DOM = Domestic <br> INT = International",
      "hint_panel" : "Indicates whether you (the source location) are shipping Domestically (DOM) or internationally (INT) <br>DOM = Domestic <br> INT = International",
      "example": "Domestic",
      "sequence": 17,
      "show_more": true,
      "lookup": [
        { 'option': '', 'title': '-' },
        {
          'option': 'DOM',
          'title': 'Domestic'
        },
        {
          'option': 'INT',
          'title': 'International'
        },
      ]
  },
  {
      "field_map": "shippingScope",
      "item_name": "BX.hazardous_materials.0.shipping_scope",
      "title": "Shipping scope",
      "hint_detail": "Indicates whether you (the source location) are shipping Domestically (DOM) or internationally (INT) <br>DOM = Domestic <br> INT = International",
      "hint_panel" : "Indicates whether you (the source location) are shipping Domestically (DOM) or internationally (INT) <br>DOM = Domestic <br> INT = International",
      "example": "Domestic",
      "sequence": 17,
      "show_more": true,
      "lookup": [
        { 'option': '', 'title': '-' },
        {
          'option': 'DOM',
          'title': 'Domestic'
        },
        {
          'option': 'INT',
          'title': 'International'
        },
      ]
  },
  {
      "field_map": "shippingScope",
      "item_name": "CA.hazardous_materials.0.shipping_scope",
      "title": "Shipping scope",
      "hint_detail": "Indicates whether you (the source location) are shipping Domestically (DOM) or internationally (INT) <br>DOM = Domestic <br> INT = International",
      "hint_panel" : "Indicates whether you (the source location) are shipping Domestically (DOM) or internationally (INT) <br>DOM = Domestic <br> INT = International",
      "example": "Domestic",
      "sequence": 17,
      "show_more": true,
      "lookup": [
        { 'option': '', 'title': '-' },
        {
          'option': 'DOM',
          'title': 'Domestic'
        },
        {
          'option': 'INT',
          'title': 'International'
        },
      ]
  },
  {
      "field_map": "shippingScope",
      "item_name": "PL.hazardous_materials.0.shipping_scope",
      "title": "Shipping scope",
      "hint_detail": "Indicates whether you (the source location) are shipping Domestically (DOM) or internationally (INT) <br>DOM = Domestic <br> INT = International",
      "hint_panel" : "Indicates whether you (the source location) are shipping Domestically (DOM) or internationally (INT) <br>DOM = Domestic <br> INT = International",
      "example": "Domestic",
      "sequence": 17,
      "show_more": true,
      "lookup": [
        { 'option': '', 'title': '-' },
        {
          'option': 'DOM',
          'title': 'Domestic'
        },
        {
          'option': 'INT',
          'title': 'International'
        },
      ]
  },
  {
      "field_map": "regulatingCountry",
      "item_name": "EA.hazardous_materials.0.regulating_country",
      "title": "Regulating country",
      "hint_detail": "Using the ISO country codes, the country from which the goods are initially shipped.",
      "hint_panel" : "Identify, using the ISO country codes, the country from which the goods are initially shipped. <br>NOTE: This is different from the documentation you may require if shipping across several countries (IE â€“ Country of Origin â€“ US; Trans-ship to France via UK)",
      "example": "United States",
      "sequence": 19,
      "show_more": true,
      "lookup": countryLookup,
  },
  {
      "field_map": "regulatingCountry",
      "item_name": "PK.hazardous_materials.0.regulating_country",
      "title": "Regulating country",
      "hint_detail": "Using the ISO country codes, the country from which the goods are initially shipped.",
      "hint_panel" : "Identify, using the ISO country codes, the country from which the goods are initially shipped. <br>NOTE: This is different from the documentation you may require if shipping across several countries (IE â€“ Country of Origin â€“ US; Trans-ship to France via UK)",
      "example": "United States",
      "sequence": 19,
      "show_more": true,
      "lookup": countryLookup,
  },
  {
      "field_map": "regulatingCountry",
      "item_name": "BX.hazardous_materials.0.regulating_country",
      "title": "Regulating country",
      "hint_detail": "Using the ISO country codes, the country from which the goods are initially shipped.",
      "hint_panel" : "Identify, using the ISO country codes, the country from which the goods are initially shipped. <br>NOTE: This is different from the documentation you may require if shipping across several countries (IE â€“ Country of Origin â€“ US; Trans-ship to France via UK)",
      "example": "United States",
      "sequence": 19,
      "show_more": true,
      "lookup": countryLookup,
  },
  {
      "field_map": "regulatingCountry",
      "item_name": "CA.hazardous_materials.0.regulating_country",
      "title": "Regulating country",
      "hint_detail": "Using the ISO country codes, the country from which the goods are initially shipped.",
      "hint_panel" : "Identify, using the ISO country codes, the country from which the goods are initially shipped. <br>NOTE: This is different from the documentation you may require if shipping across several countries (IE â€“ Country of Origin â€“ US; Trans-ship to France via UK)",
      "example": "United States",
      "sequence": 19,
      "show_more": true,
      "lookup": countryLookup,
  },
  {
      "field_map": "regulatingCountry",
      "item_name": "PL.hazardous_materials.0.regulating_country",
      "title": "Regulating country",
      "hint_detail": "Using the ISO country codes, the country from which the goods are initially shipped.",
      "hint_panel" : "Identify, using the ISO country codes, the country from which the goods are initially shipped. <br>NOTE: This is different from the documentation you may require if shipping across several countries (IE â€“ Country of Origin â€“ US; Trans-ship to France via UK)",
      "example": "United States",
      "sequence": 19,
      "show_more": true,
      "lookup": countryLookup,
  },
  {
      "field_map": "bulk",
      "item_name": "EA.hazardous_materials.0.bulk",
      "title": "Bulk",
      "hint_detail": "Indicates whether the goods shipped are being shipped in bulk (B) or non-bulk (N). <br>B = Bulk <br>N = Non-Bulk",
      "hint_panel" : "Indicates whether the goods shipped are being shipped in bulk (B) or non-bulk (N). <br>B = Bulk <br>N = Non-Bulk",
      "example": "Bulk",
      "sequence": 18,
      "show_more": true,
      "lookup": [
        { 'option': '', 'title': '-' },
        {
          "option": "N",
          "title": "Non bulk"
        },
        {
          "option": "B",
          "title": "Bulk"
        }
      ]
  },
  {
      "field_map": "bulk",
      "item_name": "PK.hazardous_materials.0.bulk",
      "title": "Bulk",
      "hint_detail": "Indicates whether the goods shipped are being shipped in bulk (B) or non-bulk (N). <br>B = Bulk <br>N = Non-Bulk",
      "hint_panel" : "Indicates whether the goods shipped are being shipped in bulk (B) or non-bulk (N). <br>B = Bulk <br>N = Non-Bulk",
      "example": "Bulk",
      "sequence": 18,
      "show_more": true,
      "lookup": [
        { 'option': '', 'title': '-' },
        {
          "option": "N",
          "title": "Non bulk"
        },
        {
          "option": "B",
          "title": "Bulk"
        }
      ]
  },
  {
      "field_map": "bulk",
      "item_name": "BX.hazardous_materials.0.bulk",
      "title": "Bulk",
      "hint_detail": "Indicates whether the goods shipped are being shipped in bulk (B) or non-bulk (N). <br>B = Bulk <br>N = Non-Bulk",
      "hint_panel" : "Indicates whether the goods shipped are being shipped in bulk (B) or non-bulk (N). <br>B = Bulk <br>N = Non-Bulk",
      "example": "Bulk",
      "sequence": 18,
      "show_more": true,
      "lookup": [
        { 'option': '', 'title': '-' },
        {
          "option": "N",
          "title": "Non bulk"
        },
        {
          "option": "B",
          "title": "Bulk"
        }
      ]
  },
  {
      "field_map": "bulk",
      "item_name": "CA.hazardous_materials.0.bulk",
      "title": "Bulk",
      "hint_detail": "Indicates whether the goods shipped are being shipped in bulk (B) or non-bulk (N). <br>B = Bulk <br>N = Non-Bulk",
      "hint_panel" : "Indicates whether the goods shipped are being shipped in bulk (B) or non-bulk (N). <br>B = Bulk <br>N = Non-Bulk",
      "example": "Bulk",
      "sequence": 18,
      "show_more": true,
      "lookup": [
        { 'option': '', 'title': '-' },
        {
          "option": "N",
          "title": "Non bulk"
        },
        {
          "option": "B",
          "title": "Bulk"
        }
      ]
  },
  {
      "field_map": "bulk",
      "item_name": "PL.hazardous_materials.0.bulk",
      "title": "Bulk",
      "hint_detail": "Indicates whether the goods shipped are being shipped in bulk (B) or non-bulk (N). <br>B = Bulk <br>N = Non-Bulk",
      "hint_panel" : "Indicates whether the goods shipped are being shipped in bulk (B) or non-bulk (N). <br>B = Bulk <br>N = Non-Bulk",
      "example": "Bulk",
      "sequence": 18,
      "show_more": true,
      "lookup": [
        { 'option': '', 'title': '-' },
        {
          "option": "N",
          "title": "Non bulk"
        },
        {
          "option": "B",
          "title": "Bulk"
        }
      ]
  },
  {
      "field_map": "transportMethod",
      "item_name": "EA.hazardous_materials.0.transport_method",
      "title": "Transport method",
      "hint_detail": "Indicates the principal mode of shipping. ",
      "hint_panel" : "Indicates the long-haul method of shipping used: Air, Rail, Truck, Vessel. NOTE: if country of origin is Canada, replace Truck with Road, and Vessel with Marine.",
      "example": "Air",
      "sequence": 20,
      "show_more": true,
      "lookup": [
        {
          "option": "",
          "title": "-"
        },
        {
          "option": "A",
          "title": "Air"
        },
        {
          "option": "R",
          "title": "Rail"
        },
        {
          "option": "T",
          "title": "Truck (Canada: \"Road\")"
        },
        {
          "option": "V",
          "title": "Vessel (Canada: \"Marine\")"
        }
      ]
  },
  {
      "field_map": "transportMethod",
      "item_name": "PK.hazardous_materials.0.transport_method",
      "title": "Transport method",
      "hint_detail": "Indicates the principal mode of shipping. ",
      "hint_panel" : "Indicates the long-haul method of shipping used: Air, Rail, Truck, Vessel. NOTE: if country of origin is Canada, replace Truck with Road, and Vessel with Marine.",
      "example": "Air",
      "sequence": 20,
      "show_more": true,
      "lookup": [
        { 'option': '', 'title': '-' },
        {
          "option": "A",
          "title": "Air"
        },
        {
          "option": "R",
          "title": "Rail"
        },
        {
          "option": "T",
          "title": "Truck (Canada: \"Road\")"
        },
        {
          "option": "V",
          "title": "Vessel (Canada: \"Marine\")"
        }
      ]
  },
  {
      "field_map": "transportMethod",
      "item_name": "BX.hazardous_materials.0.transport_method",
      "title": "Transport method",
      "hint_detail": "Indicates the principal mode of shipping. ",
      "hint_panel" : "Indicates the long-haul method of shipping used: Air, Rail, Truck, Vessel. NOTE: if country of origin is Canada, replace Truck with Road, and Vessel with Marine.",
      "example": "Air",
      "sequence": 20,
      "show_more": true,
      "lookup": [
        { 'option': '', 'title': '-' },
        {
          "option": "A",
          "title": "Air"
        },
        {
          "option": "R",
          "title": "Rail"
        },
        {
          "option": "T",
          "title": "Truck (Canada: \"Road\")"
        },
        {
          "option": "V",
          "title": "Vessel (Canada: \"Marine\")"
        }
      ]
  },
  {
      "field_map": "transportMethod",
      "item_name": "CA.hazardous_materials.0.transport_method",
      "title": "Transport method",
      "hint_detail": "Indicates the principal mode of shipping. ",
      "hint_panel" : "Indicates the long-haul method of shipping used: Air, Rail, Truck, Vessel. NOTE: if country of origin is Canada, replace Truck with Road, and Vessel with Marine.",
      "example": "Air",
      "sequence": 20,
      "show_more": true,
      "lookup": [
        { 'option': '', 'title': '-' },
        {
          "option": "A",
          "title": "Air"
        },
        {
          "option": "R",
          "title": "Rail"
        },
        {
          "option": "T",
          "title": "Truck (Canada: \"Road\")"
        },
        {
          "option": "V",
          "title": "Vessel (Canada: \"Marine\")"
        }
      ]
  },
  {
      "field_map": "transportMethod",
      "item_name": "PL.hazardous_materials.0.transport_method",
      "title": "Transport method",
      "hint_detail": "Indicates the principal mode of shipping. ",
      "hint_panel" : "Indicates the long-haul method of shipping used: Air, Rail, Truck, Vessel. NOTE: if country of origin is Canada, replace Truck with Road, and Vessel with Marine.",
      "example": "Air",
      "sequence": 20,
      "show_more": true,
      "lookup": [
        { 'option': '', 'title': '-' },
        {
          "option": "A",
          "title": "Air"
        },
        {
          "option": "R",
          "title": "Rail"
        },
        {
          "option": "T",
          "title": "Truck (Canada: \"Road\")"
        },
        {
          "option": "V",
          "title": "Vessel (Canada: \"Marine\")"
        }
      ]
  },
  {
      "field_map": "regulated",
      "item_name": "EA.hazardous_materials.0.regulated.regulated",
      "title": "Regulated",
      "hint_detail": "Indicates if the item is regulated.",
      "hint_panel" : "Yes or No if the goods are regulated or not.",
      "example": "Yes",
      "sequence": 21,
      "show_more": true,
      "lookup": yesNoLookup,
  },
  {
      "field_map": "regulated",
      "item_name": "PK.hazardous_materials.0.regulated.regulated",
      "title": "Regulated",
      "hint_detail": "Indicates if the item is regulated.",
      "hint_panel" : "Yes or No if the goods are regulated or not.",
      "example": "Yes",
      "sequence": 21,
      "show_more": true,
      "lookup": yesNoLookup,
  },
  {
      "field_map": "regulated",
      "item_name": "BX.hazardous_materials.0.regulated.regulated",
      "title": "Regulated",
      "hint_detail": "Indicates if the item is regulated.",
      "hint_panel" : "Yes or No if the goods are regulated or not.",
      "example": "Yes",
      "sequence": 21,
      "show_more": true,
      "lookup": yesNoLookup,
  },
  {
      "field_map": "regulated",
      "item_name": "CA.hazardous_materials.0.regulated.regulated",
      "title": "Regulated",
      "hint_detail": "Indicates if the item is regulated.",
      "hint_panel" : "Yes or No if the goods are regulated or not.",
      "example": "Yes",
      "sequence": 21,
      "show_more": true,
      "lookup": yesNoLookup,
  },
  {
      "field_map": "regulated",
      "item_name": "PL.hazardous_materials.0.regulated.regulated",
      "title": "Regulated",
      "hint_detail": "Indicates if the item is regulated.",
      "hint_panel" : "Yes or No if the goods are regulated or not.",
      "example": "Yes",
      "sequence": 21,
      "show_more": true,
      "lookup": yesNoLookup,
  },
  {
      "field_map": "hazardousClass",
      "item_name": "EA.hazardous_materials.0.regulated.hazardous_class",
      "title": "Hazardous class (separate with commas)",
      "hint_detail": "If item is regulated, please use the appropriate referable Hazardous Class. May be multiple classes such as 2.3,3.2 or ORM-AIR",
      "hint_panel" : "If item is regulated, please use the appropriate referable Hazardous Class. May be multiple classes such as 2.3,3.2 or ORM-AIR",
      "example": "2.3,3.2,ORM-AIR",
      "sequence": 21,
      "show_more": true,
      'validation': {
        'pies65' : {
          minLength: 1,
          maxLength:10,
          required: false,
          message: 'Hazardous class is required when regulated and must be no more than 10 characters.'
        }
      },
      "lookup": null
  },
  {
      "field_map": "hazardousClass",
      "item_name": "PK.hazardous_materials.0.regulated.hazardous_class",
      "title": "Hazardous class (separate with commas)",
      "hint_detail": "If item is regulated, please use the appropriate referable Hazardous Class. May be multiple classes such as 2.3,3.2 or ORM-AIR",
      "hint_panel" : "If item is regulated, please use the appropriate referable Hazardous Class. May be multiple classes such as 2.3,3.2 or ORM-AIR",
      "example": "2.3,3.2,ORM-AIR",
      "sequence": 21,
      "show_more": true,
      'validation': {
        'pies65' : {
          minLength: 1,
          maxLength:10,
          required: false,
          message: 'Hazardous class is required when regulated and must be no more than 10 characters.'
        }
      },
      "lookup": null
  },
  {
      "field_map": "hazardousClass",
      "item_name": "BX.hazardous_materials.0.regulated.hazardous_class",
      "title": "Hazardous class (separate with commas)",
      "hint_detail": "If item is regulated, please use the appropriate referable Hazardous Class. May be multiple classes such as 2.3,3.2 or ORM-AIR",
      "hint_panel" : "If item is regulated, please use the appropriate referable Hazardous Class. May be multiple classes such as 2.3,3.2 or ORM-AIR",
      "example": "2.3,3.2,ORM-AIR",
      "sequence": 21,
      "show_more": true,
      'validation': {
        'pies65' : {
          minLength: 1,
          maxLength:10,
          required: false,
          message: 'Hazardous class is required when regulated and must be no more than 10 characters.'
        }
      },
      "lookup": null
  },
  {
      "field_map": "hazardousClass",
      "item_name": "CA.hazardous_materials.0.regulated.hazardous_class",
      "title": "Hazardous class (separate with commas)",
      "hint_detail": "If item is regulated, please use the appropriate referable Hazardous Class. May be multiple classes such as 2.3,3.2 or ORM-AIR",
      "hint_panel" : "If item is regulated, please use the appropriate referable Hazardous Class. May be multiple classes such as 2.3,3.2 or ORM-AIR",
      "example": "2.3,3.2,ORM-AIR",
      "sequence": 21,
      "show_more": true,
      'validation': {
        'pies65' : {
          minLength: 1,
          maxLength:10,
          required: false,
          message: 'Hazardous class is required when regulated and must be no more than 10 characters.'
        }
      },
      "lookup": null
  },
  {
      "field_map": "hazardousClass",
      "item_name": "PL.hazardous_materials.0.regulated.hazardous_class",
      "title": "Hazardous class (separate with commas)",
      "hint_detail": "If item is regulated, please use the appropriate referable Hazardous Class. May be multiple classes such as 2.3,3.2 or ORM-AIR",
      "hint_panel" : "If item is regulated, please use the appropriate referable Hazardous Class. May be multiple classes such as 2.3,3.2 or ORM-AIR",
      "example": "2.3,3.2,ORM-AIR",
      "sequence": 21,
      "show_more": true,
      'validation': {
        'pies65' : {
          minLength: 1,
          maxLength:10,
          required: false,
          message: 'Hazardous class is required when regulated and must be no more than 10 characters.'
        }
      },
      "lookup": null
  },
  {
      "field_map": "outerPackageLabel",
      "item_name": "EA.hazardous_materials.0.regulated.outer_package_label",
      "title": "Outer package label",
      "hint_detail": "If item is regulated, indicates the relevant Hazardous Material Class for the Outer Package Label.",
      "hint_panel" : "If item is regulated, indicate the relevant Hazardous Material Class for the Outer Package Label.",
      "example": "ORM-AIR",
      "sequence": 22,
      "show_more": true,
      'validation': {
        'pies65' : {
          minLength: 1,
          maxLength: 20,
          required: false,
          message: 'Outer package label is required when regulated and must be no more than 20 characters.'
        }
      },
      "lookup": null
  },
  {
      "field_map": "outerPackageLabel",
      "item_name": "PK.hazardous_materials.0.regulated.outer_package_label",
      "title": "Outer package label",
      "hint_detail": "If item is regulated, indicates the relevant Hazardous Material Class for the Outer Package Label.",
      "hint_panel" : "If item is regulated, indicate the relevant Hazardous Material Class for the Outer Package Label.",
      "example": "ORM-AIR",
      "sequence": 22,
      "show_more": true,
      'validation': {
        'pies65' : {
          minLength: 1,
          maxLength: 20,
          required: false,
          message: 'Outer package label is required when regulated and must be no more than 20 characters.'
        }
      },
      "lookup": null
  },
  {
      "field_map": "outerPackageLabel",
      "item_name": "BX.hazardous_materials.0.regulated.outer_package_label",
      "title": "Outer package label",
      "hint_detail": "If item is regulated, indicates the relevant Hazardous Material Class for the Outer Package Label.",
      "hint_panel" : "If item is regulated, indicate the relevant Hazardous Material Class for the Outer Package Label.",
      "example": "ORM-AIR",
      "sequence": 22,
      "show_more": true,
      'validation': {
        'pies65' : {
          minLength: 1,
          maxLength: 20,
          required: false,
          message: 'Outer package label is required when regulated and must be no more than 20 characters.'
        }
      },
      "lookup": null
  },
  {
      "field_map": "outerPackageLabel",
      "item_name": "CA.hazardous_materials.0.regulated.outer_package_label",
      "title": "Outer package label",
      "hint_detail": "If item is regulated, indicates the relevant Hazardous Material Class for the Outer Package Label.",
      "hint_panel" : "If item is regulated, indicate the relevant Hazardous Material Class for the Outer Package Label.",
      "example": "ORM-AIR",
      "sequence": 22,
      "show_more": true,
      'validation': {
        'pies65' : {
          minLength: 1,
          maxLength: 20,
          required: false,
          message: 'Outer package label is required when regulated and must be no more than 20 characters.'
        }
      },
      "lookup": null
  },
  {
      "field_map": "outerPackageLabel",
      "item_name": "PL.hazardous_materials.0.regulated.outer_package_label",
      "title": "Outer package label",
      "hint_detail": "If item is regulated, indicates the relevant Hazardous Material Class for the Outer Package Label.",
      "hint_panel" : "If item is regulated, indicate the relevant Hazardous Material Class for the Outer Package Label.",
      "example": "ORM-AIR",
      "sequence": 22,
      "show_more": true,
      'validation': {
        'pies65' : {
          minLength: 1,
          maxLength: 20,
          required: false,
          message: 'Outer package label is required when regulated and must be no more than 20 characters.'
        }
      },
      "lookup": null
  },
  {
      "field_map": "unnaidCode",
      "item_name": "EA.hazardous_materials.0.regulated.unnaid_code",
      "title": "UN/NA ID code",
      "hint_detail": "UN / NA # United Nations (UN) Numbers are four-digit numbers used to identify hazardous chemicals or classes of hazardous materials worldwide. North American (NA) Numbers are identical to UN numbers. If a material does not have a UN number, it may be assigned an NA number.",
      "hint_panel" : "UN / NA # United Nations (UN) Numbers are four-digit numbers used to identify hazardous chemicals or classes of hazardous materials worldwide. North American (NA) Numbers are identical to UN numbers. If a material does not have a UN number, it may be assigned an NA number.",
      "example": "ID8000",
      "sequence": 23,
      "show_more": true,
      'validation': {
        'pies65' : {
          length: 6,
          required: false,
          message: 'UN/NA ID is required when regulated and code must be exactly 6 characters.'
        }
      },
      "lookup": null
  },
  {
      "field_map": "unnaidCode",
      "item_name": "PK.hazardous_materials.0.regulated.unnaid_code",
      "title": "UN/NA ID code",
      "hint_detail": "UN / NA # United Nations (UN) Numbers are four-digit numbers used to identify hazardous chemicals or classes of hazardous materials worldwide. North American (NA) Numbers are identical to UN numbers. If a material does not have a UN number, it may be assigned an NA number.",
      "hint_panel" : "UN / NA # United Nations (UN) Numbers are four-digit numbers used to identify hazardous chemicals or classes of hazardous materials worldwide. North American (NA) Numbers are identical to UN numbers. If a material does not have a UN number, it may be assigned an NA number.",
      "example": "ID8000",
      "sequence": 23,
      "show_more": true,
      'validation': {
        'pies65' : {
          length: 6,
          required: false,
          message: 'UN/NA ID is required when regulated and code must be exactly 6 characters.'
        }
      },
      "lookup": null
  },
  {
      "field_map": "unnaidCode",
      "item_name": "BX.hazardous_materials.0.regulated.unnaid_code",
      "title": "UN/NA ID code",
      "hint_detail": "UN / NA # United Nations (UN) Numbers are four-digit numbers used to identify hazardous chemicals or classes of hazardous materials worldwide. North American (NA) Numbers are identical to UN numbers. If a material does not have a UN number, it may be assigned an NA number.",
      "hint_panel" : "UN / NA # United Nations (UN) Numbers are four-digit numbers used to identify hazardous chemicals or classes of hazardous materials worldwide. North American (NA) Numbers are identical to UN numbers. If a material does not have a UN number, it may be assigned an NA number.",
      "example": "ID8000",
      "sequence": 23,
      "show_more": true,
      'validation': {
        'pies65' : {
          length: 6,
          required: false,
          message: 'UN/NA ID is required when regulated and code must be exactly 6 characters.'
        }
      },
      "lookup": null
  },
  {
      "field_map": "unnaidCode",
      "item_name": "CA.hazardous_materials.0.regulated.unnaid_code",
      "title": "UN/NA ID code",
      "hint_detail": "UN / NA # United Nations (UN) Numbers are four-digit numbers used to identify hazardous chemicals or classes of hazardous materials worldwide. North American (NA) Numbers are identical to UN numbers. If a material does not have a UN number, it may be assigned an NA number.",
      "hint_panel" : "UN / NA # United Nations (UN) Numbers are four-digit numbers used to identify hazardous chemicals or classes of hazardous materials worldwide. North American (NA) Numbers are identical to UN numbers. If a material does not have a UN number, it may be assigned an NA number.",
      "example": "ID8000",
      "sequence": 23,
      "show_more": true,
      'validation': {
        'pies65' : {
          length: 6,
          required: false,
          message: 'UN/NA ID is required when regulated and code must be exactly 6 characters.'
        }
      },
      "lookup": null
  },
  {
      "field_map": "unnaidCode",
      "item_name": "PL.hazardous_materials.0.regulated.unnaid_code",
      "title": "UN/NA ID code",
      "hint_detail": "UN / NA # United Nations (UN) Numbers are four-digit numbers used to identify hazardous chemicals or classes of hazardous materials worldwide. North American (NA) Numbers are identical to UN numbers. If a material does not have a UN number, it may be assigned an NA number.",
      "hint_panel" : "UN / NA # United Nations (UN) Numbers are four-digit numbers used to identify hazardous chemicals or classes of hazardous materials worldwide. North American (NA) Numbers are identical to UN numbers. If a material does not have a UN number, it may be assigned an NA number.",
      "example": "ID8000",
      "sequence": 23,
      "show_more": true,
      'validation': {
        'pies65' : {
          length: 6,
          required: false,
          message: 'UN/NA ID is required when regulated and code must be exactly 6 characters.'
        }
      },
      "lookup": null
  },
  {
      "field_map": "shippingName",
      "item_name": "EA.hazardous_materials.0.regulated.shipping_name",
      "title": "Shipping name",
      "hint_detail": "Name of hazardous commodity. Can include shipping instructions.",
      "hint_panel" : "Name of hazardous commodity. Can include shipping instructions. Required if â€œRegulatedâ€ is Yes.",
      "example": "Flammable Aerosol",
      "sequence": 24,
      "show_more": true,
      'validation': {
        'pies65' : {
          minLength: 1,
          maxLength: 260,
          required: false,
          message: 'Shipping name is required when regulated and must be no more than 260 characters.'
        }
      },
      "lookup": null
  },
  {
      "field_map": "shippingName",
      "item_name": "PK.hazardous_materials.0.regulated.shipping_name",
      "title": "Shipping name",
      "hint_detail": "Name of hazardous commodity. Can include shipping instructions.",
      "hint_panel" : "Name of hazardous commodity. Can include shipping instructions. Required if â€œRegulatedâ€ is Yes.",
      "example": "Flammable Aerosol",
      "sequence": 24,
      "show_more": true,
      'validation': {
        'pies65' : {
          minLength: 1,
          maxLength: 260,
          required: false,
          message: 'Shipping name is required when regulated and must be no more than 260 characters.'
        }
      },
      "lookup": null
  },
  {
      "field_map": "shippingName",
      "item_name": "BX.hazardous_materials.0.regulated.shipping_name",
      "title": "Shipping name",
      "hint_detail": "Name of hazardous commodity. Can include shipping instructions.",
      "hint_panel" : "Name of hazardous commodity. Can include shipping instructions. Required if â€œRegulatedâ€ is Yes.",
      "example": "Flammable Aerosol",
      "sequence": 24,
      "show_more": true,
      'validation': {
        'pies65' : {
          minLength: 1,
          maxLength: 260,
          required: false,
          message: 'Shipping name is required when regulated and must be no more than 260 characters.'
        }
      },
      "lookup": null
  },
  {
      "field_map": "shippingName",
      "item_name": "CA.hazardous_materials.0.regulated.shipping_name",
      "title": "Shipping name",
      "hint_detail": "Name of hazardous commodity. Can include shipping instructions.",
      "hint_panel" : "Name of hazardous commodity. Can include shipping instructions. Required if â€œRegulatedâ€ is Yes.",
      "example": "Flammable Aerosol",
      "sequence": 24,
      "show_more": true,
      'validation': {
        'pies65' : {
          minLength: 1,
          maxLength: 260,
          required: false,
          message: 'Shipping name is required when regulated and must be no more than 260 characters.'
        }
      },
      "lookup": null
  },
  {
      "field_map": "shippingName",
      "item_name": "PL.hazardous_materials.0.regulated.shipping_name",
      "title": "Shipping name",
      "hint_detail": "Name of hazardous commodity. Can include shipping instructions.",
      "hint_panel" : "Name of hazardous commodity. Can include shipping instructions. Required if â€œRegulatedâ€ is Yes.",
      "example": "Flammable Aerosol",
      "sequence": 24,
      "show_more": true,
      'validation': {
        'pies65' : {
          minLength: 1,
          maxLength: 260,
          required: false,
          message: 'Shipping name is required when regulated and must be no more than 260 characters.'
        }
      },
      "lookup": null
  },
  {
      "field_map": "description",
      "item_name": "EA.hazardous_materials.0.regulated.description",
      "title": "Description",
      "hint_detail": "Description of the Hazardous material.",
      "hint_panel" : "Enter description of the Hazardous material.",
      "example": "Flammable Aerosol under high pressure.",
      "sequence": 24,
      "show_more": true,
      'validation': {
        'pies65' : {
          minLength: 1,
          maxLength: 200,
          required: false,
          message: 'Description is required when regulated and must be no more than 200 characters.'
        }
      },
      "lookup": null
  },
  {
      "field_map": "description",
      "item_name": "PK.hazardous_materials.0.regulated.description",
      "title": "Description",
      "hint_detail": "Description of the Hazardous material.",
      "hint_panel" : "Enter description of the Hazardous material.",
      "example": "Flammable Aerosol under high pressure.",
      "sequence": 24,
      "show_more": true,
      'validation': {
        'pies65' : {
          minLength: 1,
          maxLength: 200,
          required: false,
          message: 'Description is required when regulated and must be no more than 200 characters.'
        }
      },
      "lookup": null
  },
  {
      "field_map": "description",
      "item_name": "BX.hazardous_materials.0.regulated.description",
      "title": "Description",
      "hint_detail": "Description of the Hazardous material.",
      "hint_panel" : "Enter description of the Hazardous material.",
      "example": "Flammable Aerosol under high pressure.",
      "sequence": 24,
      "show_more": true,
      'validation': {
        'pies65' : {
          minLength: 1,
          maxLength: 200,
          required: false,
          message: 'Description is required when regulated and must be no more than 200 characters.'
        }
      },
      "lookup": null
  },
  {
      "field_map": "description",
      "item_name": "CA.hazardous_materials.0.regulated.description",
      "title": "Description",
      "hint_detail": "Description of the Hazardous material.",
      "hint_panel" : "Enter description of the Hazardous material.",
      "example": "Flammable Aerosol under high pressure.",
      "sequence": 24,
      "show_more": true,
      'validation': {
        'pies65' : {
          minLength: 1,
          maxLength: 200,
          required: false,
          message: 'Description is required when regulated and must be no more than 200 characters.'
        }
      },
      "lookup": null
  },
  {
      "field_map": "description",
      "item_name": "PL.hazardous_materials.0.regulated.description",
      "title": "Description",
      "hint_detail": "Description of the Hazardous material.",
      "hint_panel" : "Enter description of the Hazardous material.",
      "example": "Flammable Aerosol under high pressure.",
      "sequence": 24,
      "show_more": true,
      'validation': {
        'pies65' : {
          minLength: 1,
          maxLength: 200,
          required: false,
          message: 'Description is required when regulated and must be no more than 200 characters.'
        }
      },
      "lookup": null
  },
  {
      "field_map": "hazardousMaterialCodeQualifier",
      "item_name": "EA.hazardous_materials.0.hazardous_material_code_qualifier",
      "title": "Hazmat code qualifier",
      "hint_detail": "Department of Transport Hazardous Material Code List",
      "hint_panel" : "Department of Transport Hazardous Material Code List",
      "example": "",
      "sequence": 24,
      "show_more": true,
      "lookup": [
        { 'option': '', 'title': '-' },
        {
          "option": "D",
          "title": "Department of Transport Hazardous Material Code List"
        }
      ]
  },
  {
      "field_map": "hazardousMaterialCodeQualifier",
      "item_name": "PK.hazardous_materials.0.hazardous_material_code_qualifier",
      "title": "Hazmat code qualifier",
      "hint_detail": "Department of Transport Hazardous Material Code List",
      "hint_panel" : "Department of Transport Hazardous Material Code List",
      "example": "",
      "sequence": 24,
      "show_more": true,
      "lookup": [
        { 'option': '', 'title': '-' },
        {
          "option": "D",
          "title": "Department of Transport Hazardous Material Code List"
        }
      ]
  },
  {
      "field_map": "hazardousMaterialCodeQualifier",
      "item_name": "BX.hazardous_materials.0.hazardous_material_code_qualifier",
      "title": "Hazmat code qualifier",
      "hint_detail": "Department of Transport Hazardous Material Code List",
      "hint_panel" : "Department of Transport Hazardous Material Code List",
      "example": "",
      "sequence": 24,
      "show_more": true,
      "lookup": [
        { 'option': '', 'title': '-' },
        {
          "option": "D",
          "title": "Department of Transport Hazardous Material Code List"
        }
      ]
  },
  {
      "field_map": "hazardousMaterialCodeQualifier",
      "item_name": "CA.hazardous_materials.0.hazardous_material_code_qualifier",
      "title": "Hazmat code qualifier",
      "hint_detail": "Department of Transport Hazardous Material Code List",
      "hint_panel" : "Department of Transport Hazardous Material Code List",
      "example": "",
      "sequence": 24,
      "show_more": true,
      "lookup": [
        { 'option': '', 'title': '-' },
        {
          "option": "D",
          "title": "Department of Transport Hazardous Material Code List"
        }
      ]
  },
  {
      "field_map": "hazardousMaterialCodeQualifier",
      "item_name": "PL.hazardous_materials.0.hazardous_material_code_qualifier",
      "title": "Hazmat code qualifier",
      "hint_detail": "Department of Transport Hazardous Material Code List",
      "hint_panel" : "Department of Transport Hazardous Material Code List",
      "example": "",
      "sequence": 24,
      "show_more": true,
      "lookup": [
        { 'option': '', 'title': '-' },
        {
          "option": "D",
          "title": "Department of Transport Hazardous Material Code List"
        }
      ]
  },
  {
      "field_map": "hazardousMaterialClassCode",
      "item_name": "EA.hazardous_materials.0.hazardous_material_class_code",
      "title": "HAZMAT class code",
      "hint_detail": "Hazardous materials class code",
      "hint_panel" : "Hazardous materials class code",
      "example": "Explosives projected",
      "sequence": 25,
      "show_more": true,
      "lookup": [
        { 'option': '', 'title': '-' },
        {
          "option": "1.1",
          "title": "Explosives"
        },
        {
          "option": "1.2",
          "title": "Explosives projected"
        },
        {
          "option": "1.3",
          "title": "Explosives fire"
        },
        {
          "option": "1.4",
          "title": "Explosives no blast"
        },
        {
          "option": "1.5",
          "title": "Very insensitive explos"
        },
        {
          "option": "1.6",
          "title": "Extremely insensitive"
        },
        {
          "option": "2.1",
          "title": "Flammable gas"
        },
        {
          "option": "2.2",
          "title": "Non-flammable gas"
        },
        {
          "option": "2.3",
          "title": "Poisonous gas"
        },
        {
          "option": "3",
          "title": "Flammable liquid"
        },
        {
          "option": "4.1",
          "title": "Flammable solid"
        },
        {
          "option": "4.2",
          "title": "Combustible material"
        },
        {
          "option": "4.3",
          "title": "Dangerous when wet"
        },
        {
          "option": "5.1",
          "title": "Oxidizer"
        },
        {
          "option": "5.2",
          "title": "Organic peroxide"
        },
        {
          "option": "6.1",
          "title": "Poisonous Material"
        },
        {
          "option": "6.2",
          "title": "Infectious substance"
        },
        {
          "option": "7",
          "title": "Radioactive"
        },
        {
          "option": "8",
          "title": "Corrosive material"
        },
        {
          "option": "9",
          "title": "Misc. haz material"
        },
      ]
  },
  {
      "field_map": "hazardousMaterialClassCode",
      "item_name": "PK.hazardous_materials.0.hazardous_material_class_code",
      "title": "HAZMAT class code",
      "hint_detail": "Hazardous materials class code",
      "hint_panel" : "Hazardous materials class code",
      "example": "Explosives projected",
      "sequence": 25,
      "show_more": true,
      "lookup": [
        { 'option': '', 'title': '-' },
        {
          "option": "1.1",
          "title": "Explosives"
        },
        {
          "option": "1.2",
          "title": "Explosives projected"
        },
        {
          "option": "1.3",
          "title": "Explosives fire"
        },
        {
          "option": "1.4",
          "title": "Explosives no blast"
        },
        {
          "option": "1.5",
          "title": "Very insensitive explos"
        },
        {
          "option": "1.6",
          "title": "Extremely insensitive"
        },
        {
          "option": "2.1",
          "title": "Flammable gas"
        },
        {
          "option": "2.2",
          "title": "Non-flammable gas"
        },
        {
          "option": "2.3",
          "title": "Poisonous gas"
        },
        {
          "option": "3",
          "title": "Flammable liquid"
        },
        {
          "option": "4.1",
          "title": "Flammable solid"
        },
        {
          "option": "4.2",
          "title": "Combustible material"
        },
        {
          "option": "4.3",
          "title": "Dangerous when wet"
        },
        {
          "option": "5.1",
          "title": "Oxidizer"
        },
        {
          "option": "5.2",
          "title": "Organic peroxide"
        },
        {
          "option": "6.1",
          "title": "Poisonous Material"
        },
        {
          "option": "6.2",
          "title": "Infectious substance"
        },
        {
          "option": "7",
          "title": "Radioactive"
        },
        {
          "option": "8",
          "title": "Corrosive material"
        },
        {
          "option": "9",
          "title": "Misc. haz material"
        },
      ]
  },
  {
      "field_map": "hazardousMaterialClassCode",
      "item_name": "BX.hazardous_materials.0.hazardous_material_class_code",
      "title": "HAZMAT class code",
      "hint_detail": "Hazardous materials class code",
      "hint_panel" : "Hazardous materials class code",
      "example": "Explosives projected",
      "sequence": 25,
      "show_more": true,
      "lookup": [
        { 'option': '', 'title': '-' },
        {
          "option": "1.1",
          "title": "Explosives"
        },
        {
          "option": "1.2",
          "title": "Explosives projected"
        },
        {
          "option": "1.3",
          "title": "Explosives fire"
        },
        {
          "option": "1.4",
          "title": "Explosives no blast"
        },
        {
          "option": "1.5",
          "title": "Very insensitive explos"
        },
        {
          "option": "1.6",
          "title": "Extremely insensitive"
        },
        {
          "option": "2.1",
          "title": "Flammable gas"
        },
        {
          "option": "2.2",
          "title": "Non-flammable gas"
        },
        {
          "option": "2.3",
          "title": "Poisonous gas"
        },
        {
          "option": "3",
          "title": "Flammable liquid"
        },
        {
          "option": "4.1",
          "title": "Flammable solid"
        },
        {
          "option": "4.2",
          "title": "Combustible material"
        },
        {
          "option": "4.3",
          "title": "Dangerous when wet"
        },
        {
          "option": "5.1",
          "title": "Oxidizer"
        },
        {
          "option": "5.2",
          "title": "Organic peroxide"
        },
        {
          "option": "6.1",
          "title": "Poisonous Material"
        },
        {
          "option": "6.2",
          "title": "Infectious substance"
        },
        {
          "option": "7",
          "title": "Radioactive"
        },
        {
          "option": "8",
          "title": "Corrosive material"
        },
        {
          "option": "9",
          "title": "Misc. haz material"
        },
      ]
  },
  {
      "field_map": "hazardousMaterialClassCode",
      "item_name": "CA.hazardous_materials.0.hazardous_material_class_code",
      "title": "HAZMAT class code",
      "hint_detail": "Hazardous materials class code",
      "hint_panel" : "Hazardous materials class code",
      "example": "Explosives projected",
      "sequence": 25,
      "show_more": true,
      "lookup": [
        { 'option': '', 'title': '-' },
        {
          "option": "1.1",
          "title": "Explosives"
        },
        {
          "option": "1.2",
          "title": "Explosives projected"
        },
        {
          "option": "1.3",
          "title": "Explosives fire"
        },
        {
          "option": "1.4",
          "title": "Explosives no blast"
        },
        {
          "option": "1.5",
          "title": "Very insensitive explos"
        },
        {
          "option": "1.6",
          "title": "Extremely insensitive"
        },
        {
          "option": "2.1",
          "title": "Flammable gas"
        },
        {
          "option": "2.2",
          "title": "Non-flammable gas"
        },
        {
          "option": "2.3",
          "title": "Poisonous gas"
        },
        {
          "option": "3",
          "title": "Flammable liquid"
        },
        {
          "option": "4.1",
          "title": "Flammable solid"
        },
        {
          "option": "4.2",
          "title": "Combustible material"
        },
        {
          "option": "4.3",
          "title": "Dangerous when wet"
        },
        {
          "option": "5.1",
          "title": "Oxidizer"
        },
        {
          "option": "5.2",
          "title": "Organic peroxide"
        },
        {
          "option": "6.1",
          "title": "Poisonous Material"
        },
        {
          "option": "6.2",
          "title": "Infectious substance"
        },
        {
          "option": "7",
          "title": "Radioactive"
        },
        {
          "option": "8",
          "title": "Corrosive material"
        },
        {
          "option": "9",
          "title": "Misc. haz material"
        },
      ]
  },
  {
      "field_map": "hazardousMaterialClassCode",
      "item_name": "PL.hazardous_materials.0.hazardous_material_class_code",
      "title": "HAZMAT class code",
      "hint_detail": "Hazardous materials class code",
      "hint_panel" : "Hazardous materials class code",
      "example": "Explosives projected",
      "sequence": 25,
      "show_more": true,
      "lookup": [
        { 'option': '', 'title': '-' },
        {
          "option": "1.1",
          "title": "Explosives"
        },
        {
          "option": "1.2",
          "title": "Explosives projected"
        },
        {
          "option": "1.3",
          "title": "Explosives fire"
        },
        {
          "option": "1.4",
          "title": "Explosives no blast"
        },
        {
          "option": "1.5",
          "title": "Very insensitive explos"
        },
        {
          "option": "1.6",
          "title": "Extremely insensitive"
        },
        {
          "option": "2.1",
          "title": "Flammable gas"
        },
        {
          "option": "2.2",
          "title": "Non-flammable gas"
        },
        {
          "option": "2.3",
          "title": "Poisonous gas"
        },
        {
          "option": "3",
          "title": "Flammable liquid"
        },
        {
          "option": "4.1",
          "title": "Flammable solid"
        },
        {
          "option": "4.2",
          "title": "Combustible material"
        },
        {
          "option": "4.3",
          "title": "Dangerous when wet"
        },
        {
          "option": "5.1",
          "title": "Oxidizer"
        },
        {
          "option": "5.2",
          "title": "Organic peroxide"
        },
        {
          "option": "6.1",
          "title": "Poisonous Material"
        },
        {
          "option": "6.2",
          "title": "Infectious substance"
        },
        {
          "option": "7",
          "title": "Radioactive"
        },
        {
          "option": "8",
          "title": "Corrosive material"
        },
        {
          "option": "9",
          "title": "Misc. haz material"
        },
      ]
  },
  {
      "field_map": "hazardousMaterialDescription",
      "item_name": "EA.hazardous_materials.0.hazardous_material_description",
      "title": "HAZMAT description",
      "hint_detail": "HAZMAT description",
      "hint_panel" : "HAZMAT description",
      "example": "HAZMAT description of the class code.",
      "sequence": 25,
      "show_more": true,
      'validation': {
        'pies65' : {
          minLength: 1,
          maxLength: 80,
          message: 'HAZMAT description must be no more than 80 characters.'
        }
      },
      "lookup": null
  },
  {
      "field_map": "hazardousMaterialDescription",
      "item_name": "PK.hazardous_materials.0.hazardous_material_description",
      "title": "HAZMAT description",
      "hint_detail": "HAZMAT description",
      "hint_panel" : "HAZMAT description",
      "example": "HAZMAT description of the class code.",
      "sequence": 25,
      "show_more": true,
      'validation': {
        'pies65' : {
          minLength: 1,
          maxLength: 80,
          message: 'HAZMAT description must be no more than 80 characters.'
        }
      },
      "lookup": null
  },
  {
      "field_map": "hazardousMaterialDescription",
      "item_name": "BX.hazardous_materials.0.hazardous_material_description",
      "title": "HAZMAT description",
      "hint_detail": "HAZMAT description",
      "hint_panel" : "HAZMAT description",
      "example": "HAZMAT description of the class code.",
      "sequence": 25,
      "show_more": true,
      'validation': {
        'pies65' : {
          minLength: 1,
          maxLength: 80,
          message: 'HAZMAT description must be no more than 80 characters.'
        }
      },
      "lookup": null
  },
  {
      "field_map": "hazardousMaterialDescription",
      "item_name": "CA.hazardous_materials.0.hazardous_material_description",
      "title": "HAZMAT description",
      "hint_detail": "HAZMAT description",
      "hint_panel" : "HAZMAT description",
      "example": "HAZMAT description of the class code.",
      "sequence": 25,
      "show_more": true,
      'validation': {
        'pies65' : {
          minLength: 1,
          maxLength: 80,
          message: 'HAZMAT description must be no more than 80 characters.'
        }
      },
      "lookup": null
  },
  {
      "field_map": "hazardousMaterialDescription",
      "item_name": "PL.hazardous_materials.0.hazardous_material_description",
      "title": "HAZMAT description",
      "hint_detail": "HAZMAT description",
      "hint_panel" : "HAZMAT description",
      "example": "HAZMAT description of the class code.",
      "sequence": 25,
      "show_more": true,
      'validation': {
        'pies65' : {
          minLength: 1,
          maxLength: 80,
          message: 'HAZMAT description must be no more than 80 characters.'
        }
      },
      "lookup": null
  },
  {
      "field_map": "whmisCode",
      "item_name": "EA.hazardous_materials.0.whmis_code",
      "title": "WHMIS code",
      "hint_detail": "WHMIS code",
      "hint_panel" : "WHMIS code",
      "example": "Flammable gas",
      "sequence": 26,
      "show_more": true,
      "lookup": whmisCodeLookup,
  },
  {
      "field_map": "whmisCode",
      "item_name": "PK.hazardous_materials.0.whmis_code",
      "title": "WHMIS code",
      "hint_detail": "WHMIS code",
      "hint_panel" : "WHMIS code",
      "example": "Flammable gas",
      "sequence": 26,
      "show_more": true,
      "lookup": whmisCodeLookup,
  },
  {
      "field_map": "whmisCode",
      "item_name": "BX.hazardous_materials.0.whmis_code",
      "title": "WHMIS code",
      "hint_detail": "WHMIS code",
      "hint_panel" : "WHMIS code",
      "example": "Flammable gas",
      "sequence": 26,
      "show_more": true,
      "lookup": whmisCodeLookup,
  },
  {
      "field_map": "whmisCode",
      "item_name": "CA.hazardous_materials.0.whmis_code",
      "title": "WHMIS code",
      "hint_detail": "WHMIS code",
      "hint_panel" : "WHMIS code",
      "example": "Flammable gas",
      "sequence": 26,
      "show_more": true,
      "lookup": whmisCodeLookup,
  },
  {
      "field_map": "whmisCode",
      "item_name": "PL.hazardous_materials.0.whmis_code",
      "title": "WHMIS code",
      "hint_detail": "WHMIS code",
      "hint_panel" : "WHMIS code",
      "example": "Flammable gas",
      "sequence": 26,
      "show_more": true,
      "lookup": whmisCodeLookup,
  },
  {
      "field_map": "whmisFreeText",
      "item_name": "EA.hazardous_materials.0.whmis_free_text",
      "title": "WHMIS description",
      "hint_detail": "WHMIS description",
      "hint_panel" : "WHMIS description",
      "example": "",
      "sequence": 27,
      "show_more": true,
      'validation': {
        'pies65' : {
          minLength: 1,
          maxLength: 80,
          message: "WHMIS description must be no more than 80 characters."
        }
      },
      "lookup": null
  },
  {
      "field_map": "whmisFreeText",
      "item_name": "PK.hazardous_materials.0.whmis_free_text",
      "title": "WHMIS description",
      "hint_detail": "WHMIS description",
      "hint_panel" : "WHMIS description",
      "example": "",
      "sequence": 27,
      "show_more": true,
      'validation': {
        'pies65' : {
          minLength: 1,
          maxLength: 80,
          message: "WHMIS description must be no more than 80 characters."
        }
      },
      "lookup": null
  },
  {
      "field_map": "whmisFreeText",
      "item_name": "BX.hazardous_materials.0.whmis_free_text",
      "title": "WHMIS description",
      "hint_detail": "WHMIS description",
      "hint_panel" : "WHMIS description",
      "example": "",
      "sequence": 27,
      "show_more": true,
      'validation': {
        'pies65' : {
          minLength: 1,
          maxLength: 80,
          message: "WHMIS description must be no more than 80 characters."
        }
      },
      "lookup": null
  },
  {
      "field_map": "whmisFreeText",
      "item_name": "CA.hazardous_materials.0.whmis_free_text",
      "title": "WHMIS description",
      "hint_detail": "WHMIS description",
      "hint_panel" : "WHMIS description",
      "example": "",
      "sequence": 27,
      "show_more": true,
      'validation': {
        'pies65' : {
          minLength: 1,
          maxLength: 80,
          message: "WHMIS description must be no more than 80 characters."
        }
      },
      "lookup": null
  },
  {
      "field_map": "whmisFreeText",
      "item_name": "PL.hazardous_materials.0.whmis_free_text",
      "title": "WHMIS description",
      "hint_detail": "WHMIS description",
      "hint_panel" : "WHMIS description",
      "example": "",
      "sequence": 27,
      "show_more": true,
      'validation': {
        'pies65' : {
          minLength: 1,
          maxLength: 80,
          message: "WHMIS description must be no more than 80 characters."
        }
      },
      "lookup": null
  },
  {
      "field_map": "packingGroupCode",
      "item_name": "EA.hazardous_materials.0.packing_group_code",
      "title": "Packing group code",
      "hint_detail": "Indicates the danger level for this hazardous material",
      "hint_panel" : "Select the danger level for this hazardous material",
      "example": "Great danger",
      "sequence": 28,
      "show_more": true,
      "lookup": [
        { 'option': '', 'title': '-' },
        {
          "option": "I",
          "title": "Great danger"
        },
        {
          "option": "II",
          "title": "Medium Danger"
        },
        {
          "option": "III",
          "title": "Low Danger"
        }
      ]
  },
  {
      "field_map": "packingGroupCode",
      "item_name": "PK.hazardous_materials.0.packing_group_code",
      "title": "Packing group code",
      "hint_detail": "Indicates the danger level for this hazardous material",
      "hint_panel" : "Select the danger level for this hazardous material",
      "example": "Great danger",
      "sequence": 28,
      "show_more": true,
      "lookup": [
        { 'option': '', 'title': '-' },
        {
          "option": "I",
          "title": "Great danger"
        },
        {
          "option": "II",
          "title": "Medium Danger"
        },
        {
          "option": "III",
          "title": "Low Danger"
        }
      ]
  },
  {
      "field_map": "packingGroupCode",
      "item_name": "BX.hazardous_materials.0.packing_group_code",
      "title": "Packing group code",
      "hint_detail": "Indicates the danger level for this hazardous material",
      "hint_panel" : "Select the danger level for this hazardous material",
      "example": "Great danger",
      "sequence": 28,
      "show_more": true,
      "lookup": [
        { 'option': '', 'title': '-' },
        {
          "option": "I",
          "title": "Great danger"
        },
        {
          "option": "II",
          "title": "Medium Danger"
        },
        {
          "option": "III",
          "title": "Low Danger"
        }
      ]
  },
  {
      "field_map": "packingGroupCode",
      "item_name": "CA.hazardous_materials.0.packing_group_code",
      "title": "Packing group code",
      "hint_detail": "Indicates the danger level for this hazardous material",
      "hint_panel" : "Select the danger level for this hazardous material",
      "example": "Great danger",
      "sequence": 28,
      "show_more": true,
      "lookup": [
        { 'option': '', 'title': '-' },
        {
          "option": "I",
          "title": "Great danger"
        },
        {
          "option": "II",
          "title": "Medium Danger"
        },
        {
          "option": "III",
          "title": "Low Danger"
        }
      ]
  },
  {
      "field_map": "packingGroupCode",
      "item_name": "PL.hazardous_materials.0.packing_group_code",
      "title": "Packing group code",
      "hint_detail": "Indicates the danger level for this hazardous material",
      "hint_panel" : "Select the danger level for this hazardous material",
      "example": "Great danger",
      "sequence": 28,
      "show_more": true,
      "lookup": [
        { 'option': '', 'title': '-' },
        {
          "option": "I",
          "title": "Great danger"
        },
        {
          "option": "II",
          "title": "Medium danger"
        },
        {
          "option": "III",
          "title": "Low danger"
        }
      ]
  },
  {
      "field_map": "regulationsExemptionCode",
      "item_name": "EA.hazardous_materials.0.regulations_exemption_code",
      "title": "Regulations exemption code",
      "hint_detail": "Regulations exemption code",
      "hint_panel" : "Regulations exemption code",
      "example": "ABCD",
      "sequence": 29,
      "show_more": true,
      'validation': {
        'pies65' : {
          minLength: 1,
          maxLength: 4,
          message: "Regulations exemption code must be no more than 4 characters."
        }
      },
      "lookup": null
  },
  {
      "field_map": "regulationsExemptionCode",
      "item_name": "PK.hazardous_materials.0.regulations_exemption_code",
      "title": "Regulations exemption code",
      "hint_detail": "Regulations exemption code",
      "hint_panel" : "Regulations exemption code",
      "example": "ABCD",
      "sequence": 29,
      "show_more": true,
      'validation': {
        'pies65' : {
          minLength: 1,
          maxLength: 4,
          message: "Regulations exemption code must be no more than 4 characters."
        }
      },
      "lookup": null
  },
  {
      "field_map": "regulationsExemptionCode",
      "item_name": "BX.hazardous_materials.0.regulations_exemption_code",
      "title": "Regulations exemption code",
      "hint_detail": "Regulations exemption code",
      "hint_panel" : "Regulations exemption code",
      "example": "ABCD",
      "sequence": 29,
      "show_more": true,
      'validation': {
        'pies65' : {
          minLength: 1,
          maxLength: 4,
          message: "Regulations exemption code must be no more than 4 characters."
        }
      },
      "lookup": null
  },
  {
      "field_map": "regulationsExemptionCode",
      "item_name": "CA.hazardous_materials.0.regulations_exemption_code",
      "title": "Regulations exemption code",
      "hint_detail": "Regulations exemption code",
      "hint_panel" : "Regulations exemption code",
      "example": "ABCD",
      "sequence": 29,
      "show_more": true,
      'validation': {
        'pies65' : {
          minLength: 1,
          maxLength: 4,
          message: "Regulations exemption code must be no more than 4 characters."
        }
      },
      "lookup": null
  },
  {
      "field_map": "regulationsExemptionCode",
      "item_name": "PL.hazardous_materials.0.regulations_exemption_code",
      "title": "Regulations exemption code",
      "hint_detail": "Regulations exemption code",
      "hint_panel" : "Regulations exemption code",
      "example": "ABCD",
      "sequence": 29,
      "show_more": true,
      'validation': {
        'pies65' : {
          minLength: 1,
          maxLength: 4,
          message: "Regulations exemption code must be no more than 4 characters."
        }
      },
      "lookup": null
  },
  {
      "field_map": "hazardousPlacardNotation",
      "item_name": "EA.hazardous_materials.0.hazardous_placard_notation",
      "title": "Placard notation",
      "hint_detail": "Placard notation",
      "hint_panel" : "Placard notation",
      "example": "",
      "sequence": 30,
      "show_more": true,
      'validation': {
        'pies65' : {
          minLength: 1,
          maxLength: 40,
          message: "Placard notation must be no more than 40 characters."
        }
      },
      "lookup": null
  },
  {
      "field_map": "hazardousPlacardNotation",
      "item_name": "PK.hazardous_materials.0.hazardous_placard_notation",
      "title": "Placard notation",
      "hint_detail": "Placard notation",
      "hint_panel" : "Placard notation",
      "example": "",
      "sequence": 30,
      "show_more": true,
      'validation': {
        'pies65' : {
          minLength: 1,
          maxLength: 40,
          message: "Placard notation must be no more than 40 characters."
        }
      },
      "lookup": null
  },
  {
      "field_map": "hazardousPlacardNotation",
      "item_name": "BX.hazardous_materials.0.hazardous_placard_notation",
      "title": "Placard notation",
      "hint_detail": "Placard notation",
      "hint_panel" : "Placard notation",
      "example": "",
      "sequence": 30,
      "show_more": true,
      'validation': {
        'pies65' : {
          minLength: 1,
          maxLength: 40,
          message: "Placard notation must be no more than 40 characters."
        }
      },
      "lookup": null
  },
  {
      "field_map": "hazardousPlacardNotation",
      "item_name": "CA.hazardous_materials.0.hazardous_placard_notation",
      "title": "Placard notation",
      "hint_detail": "Placard notation",
      "hint_panel" : "Placard notation",
      "example": "",
      "sequence": 30,
      "show_more": true,
      'validation': {
        'pies65' : {
          minLength: 1,
          maxLength: 40,
          message: "Placard notation must be no more than 40 characters."
        }
      },
      "lookup": null
  },
  {
      "field_map": "hazardousPlacardNotation",
      "item_name": "PL.hazardous_materials.0.hazardous_placard_notation",
      "title": "Placard notation",
      "hint_detail": "Placard notation",
      "hint_panel" : "Placard notation",
      "example": "",
      "sequence": 30,
      "show_more": true,
      'validation': {
        'pies65' : {
          minLength: 1,
          maxLength: 40,
          message: "Placard notation must be no more than 40 characters."
        }
      },
      "lookup": null
  },
  {
      "field_map": "textMessage",
      "item_name": "EA.hazardous_materials.0.text_message",
      "title": "Text message",
      "hint_detail": "Text message",
      "hint_panel" : "Text message",
      "example": "",
      "sequence": 31,
      "show_more": true,
      'validation': {
        'pies65' : {
          minLength: 1,
          maxLength: 2000,
          message: "Text message must be no more than 2000 characters."
        }
      },
      "lookup": null
  },
  {
      "field_map": "textMessage",
      "item_name": "PK.hazardous_materials.0.text_message",
      "title": "Text message",
      "hint_detail": "Text message",
      "hint_panel" : "Text message",
      "example": "",
      "sequence": 31,
      "show_more": true,
      'validation': {
        'pies65' : {
          minLength: 1,
          maxLength: 2000,
          message: "Text message must be no more than 2000 characters."
        }
      },
      "lookup": null
  },
  {
      "field_map": "textMessage",
      "item_name": "BX.hazardous_materials.0.text_message",
      "title": "Text message",
      "hint_detail": "Text message",
      "hint_panel" : "Text message",
      "example": "",
      "sequence": 31,
      "show_more": true,
      'validation': {
        'pies65' : {
          minLength: 1,
          maxLength: 2000,
          message: "Text message must be no more than 2000 characters."
        }
      },
      "lookup": null
  },
  {
      "field_map": "textMessage",
      "item_name": "CA.hazardous_materials.0.text_message",
      "title": "Text message",
      "hint_detail": "Text message",
      "hint_panel" : "Text message",
      "example": "",
      "sequence": 31,
      "show_more": true,
      'validation': {
        'pies65' : {
          minLength: 1,
          maxLength: 2000,
          message: "Text message must be no more than 2000 characters."
        }
      },
      "lookup": null
  },
  {
      "field_map": "textMessage",
      "item_name": "PL.hazardous_materials.0.text_message",
      "title": "Text message",
      "hint_detail": "Text message",
      "hint_panel" : "Text message",
      "example": "",
      "sequence": 31,
      "show_more": true,
      'validation': {
        'pies65' : {
          minLength: 1,
          maxLength: 2000,
          message: "Text message must be no more than 2000 characters."
        }
      },
      "lookup": null
  }
];

export const extendedInformationData = [
  {
      "field_map": "msr",
      "item_name": "MSR.EN",
      "title": "MSDS required",
      "hint_detail": "Is the MSDS sheet required? Yes or no.",
      "hint_panel" : "Is the MSDS sheet required? Yes or no.",
      "example": "Yes",
      "sequence": 1,
      "show_more": true,
      "lookup": yesNoLookup,
      'validation': {
        'pies65' : {
          'custom': function (): ValidatorFn {
            return isLookupOption(yesNoLookup);
          },
          message: 'Code doesn\'t exist within the lookup.'
        }
      },
  },
  {
      "field_map": "msd",
      "item_name": "MSD.EN",
      "title": "MSDS sheet number",
      "hint_detail": "MSDS sheet number",
      "hint_panel" : "MSDS sheet number",
      "example": "",
      "sequence": 2,
      "show_more": true,
      "lookup": null,
      'validation': {
        'pies65': {
          minLength: 1,
          maxLength: 35,
          message: 'MSDS sheet number must be no more than 35 characters and is required when MSDS Required.',
        }
      },
  },
  {
      "field_map": "cto",
      "item_name": "CTO.EN",
      "title": "Country of origin (primary)",
      "hint_detail": "Primary country of origin using ISO 2166 country codes.",
      "hint_panel" : "Choose from the ISO 3166 country codes to list the country of origin.",
      "example": "United States",
      "sequence": 3,
      "show_more": true,
      "lookup": countryLookup,
  },
  {
      "field_map": "hsb",
      "item_name": "HSB.EN",
      "title": "Harmonized tariff code (Schedule B)",
      "hint_detail": "A Schedule B number is a 10-digit number used in the United States to classify physical goods for export to another country. The Schedule B is based on the international Harmonized System (HS) of 6-digit commodity classification codes.",
      "hint_panel" : "A Schedule B number is a 10-digit number used in the United States to classify physical goods for export to another country. The Schedule B is based on the international Harmonized System (HS) of 6-digit commodity classification codes.",
      "example": "0987654231",
      "sequence": 4,
      "show_more": true,
      "lookup": null,
      "numerical": true,
      'validation': {
        'pies65' : {
          'length': 10,
          'message': 'Harmonized tariff code must be exactly 10 characters.'
        }
      },
  },
  {
      "field_map": "sta",
      "item_name": "STA.EN",
      "title": "Stock status",
      "hint_detail": "Stock status of the item",
      "hint_panel" : "Select the stock status",
      "example": "Made to order",
      "sequence": 5,
      "show_more": true,
      "lookup": [
        { 'option': '', 'title': '-' },
        {
          "option": "S",
          "title": "Shelf"
        },
        {
          "option": "N",
          "title": "Made to order"
        },
        {
          "option": "Q",
          "title": "Quick-ship"
        }
      ]
  },
  {
      "field_map": "plc",
      "item_name": "PLC.EN",
      "title": "Maximum cases per pallet",
      "hint_detail": "Maximum allowable cases per pallet layer for this item.",
      "hint_panel" : "Enter the maximum allowable cases per pallet layer for this item.",
      "example": "18",
      "sequence": 6,
      "show_more": true,
      "lookup": null,
      'numerical': true,
      'validation': {
        'pies65' : {
          max: 999,
          message: "Maximum cases per pallet cannot be greater than 999",
        }
      },
  },
  {
      "field_map": "rst",
      "item_name": "RST.EN",
      "title": "Regulating state",
      "hint_detail": "Regulating state",
      "hint_panel" : "Regulating state",
      "example": "New York",
      "sequence": 7,
      "show_more": true,
      "lookup": null,
      'validation': {
        'pies65' : {
          length: 2,
          message: 'Regulating state must be exactly 2 characters.'
        }
      },
  },
  {
      "field_map": "rpc",
      "item_name": "RPC.EN",
      "title": "Regulating postal code",
      "hint_detail": "Regulating postal code",
      "hint_panel" : "Regulating postal code",
      "example": "00000",
      "sequence": 8,
      "show_more": true,
      "lookup": null,
      'validation': {
        'pies65' : {
          minLength: 5,
          maxLength: 10,
          message: "Regulating postal code must be between 5 and 10 characters."
        }
      },
  },
  {
      "field_map": "rcs",
      "item_name": "RCS.EN",
      "title": "Regulating country, state",
      "hint_detail": "Regulating country, state",
      "hint_panel" : "Regulating country, state",
      "example": "United States, New York",
      "sequence": 9,
      "show_more": true,
      "lookup": null,
      'validation': {
        'pies65' : {
          minLength: 1,
          maxLength: 50,
          message: "Regulating country, state must be no more than 50 characters."
        }
      },
  },
  {
      "field_map": "rct",
      "item_name": "RCT.EN",
      "title": "Regulating city, state",
      "hint_detail": "Regulating city, state",
      "hint_panel" : "Regulating city, state",
      "example": "New York City, New York",
      "sequence": 10,
      "show_more": true,
      "lookup": null,
      'validation': {
        'pies65' : {
          minLength: 1,
          maxLength: 50,
          message: "Regulating city, state must be no more than 50 characters."
        }
      },
  },
  {
      "field_map": "ctp",
      "item_name": "CTP.EN",
      "title": "Country of origin 2",
      "hint_detail": "Country of origin 2",
      "hint_panel" : "Country of origin 2",
      "example": "Belgium",
      "sequence": 11,
      "show_more": true,
      "lookup": countryLookup,
  },
  {
      "field_map": "ctq",
      "item_name": "CTQ.EN",
      "title": "Country of origin 3",
      "hint_detail": "Country of origin 3",
      "hint_panel" : "Country of origin 3",
      "example": "Russian Federation",
      "sequence": 12,
      "show_more": true,
      "lookup": countryLookup,
  },
  {
      "field_map": "ctr",
      "item_name": "CTR.EN",
      "title": "Country of origin 4",
      "hint_detail": "Country of origin 4",
      "hint_panel" : "Country of origin 4",
      "example": "Greenland",
      "sequence": 13,
      "show_more": true,
      "lookup": countryLookup,
  },
  {
      "field_map": "cts",
      "item_name": "CTS.EN",
      "title": "Country of origin 5",
      "hint_detail": "Country of origin 5",
      "hint_panel" : "Country of origin 5",
      "example": "Luxembourg",
      "sequence": 14,
      "show_more": true,
      "lookup": countryLookup,
  },
  {
      "field_map": "hac",
      "item_name": "HAC.EN",
      "title": "Canadian harmonizing tariff code",
      "hint_detail": "Canadian harmonizing tariff code",
      "hint_panel" : "Canadian harmonizing tariff code",
      "sequence": 15,
      "show_more": true,
      "lookup": null,
      'validation': {
        'pies65' : {
          minLength: 10,
          maxLength: 48,
          message: 'Canadian harmonizing tariff code must be between 10 and 48 characters.'
        }
      },
  },
  {
      "field_map": "hts",
      "item_name": "HTS.EN",
      "title": "Harmonized tariff code (HTS)",
      "hint_detail": "Harmonized tariff code (HTS)",
      "hint_panel" : "Harmonized tariff code (HTS)",
      "example": "4016931010",
      "sequence": 16,
      "show_more": true,
      "lookup": null,
      'validation': {
        'pies65' : {
          length: 10,
          message: 'Harmonized tariff code must be exactly 10 characters.'
        }
      },
  },
  {
      "field_map": "hz1",
      "item_name": "HZ1.EN",
      "title": "SKU-level special handling code",
      "hint_detail": "SKU-level special handling code",
      "hint_panel" : "SKU-level special handling code",
      "example": "",
      "sequence": 17,
      "show_more": true,
      "lookup": null,
      'validation': {
        'pies65' : {
          minLength: 2,
          maxLength: 3,
          message: 'SKU-level special handling code code must be between 2 and 3 characters.'
        }
      },
  },
  {
      "field_map": "naf",
      "item_name": "NAF.EN",
      "title": "NAFTA preference criterion code",
      "hint_detail": "NAFTA preference criterion code",
      "hint_panel" : "NAFTA preference criterion code",
      "example": "",
      "sequence": 18,
      "show_more": true,
      "lookup": null,
      'validation': {
        'pies65' : {
          length: 1,
          message: 'NAFTA preference criterion code be exactly 1 character.'
        }
      },
  },
  {
      "field_map": "tmc",
      "item_name": "TMC.EN",
      "title": "Trading partner movement code",
      "hint_detail": "Trading partner movement code",
      "hint_panel" : "Trading partner movement code",
      "example": "",
      "sequence": 19,
      "show_more": true,
      "lookup": null,
      'validation': {
        'pies65' : {
          length: 2,
          message: 'Trading partner movement code must be exactly 2 characters.'
        }
      },
  },
  {
      "field_map": "plm",
      "item_name": "PLM.EN",
      "title": "Pallet layer maximum",
      "hint_detail": "Maximum allowable layers per pallet for this item.",
      "hint_panel" : "Enter the maximum allowable layers per pallet for this item.",
      "example": "2",
      "sequence": 20,
      "show_more": true,
      'validation': {
        'pies65' : {
          max: 999,
          message: "Pallet layer maximum cannot be greater than 999"
        }
      },
      "lookup": null
  },
  {
    "field_map": "ltm",
    "item_name": "LTM.EN",
    "title": "Estimated Lead Time",
    "hint_detail": "The estimated lead-time from date of order to shipment, in elapsed calendar days, as a snapshot in time. This estimate is not a guarantee.",
    "hint_panel" : "The estimated lead-time from date of order to shipment, in elapsed calendar days, as a snapshot in time. This estimate is not a guarantee.",
    "example": "",
    "sequence": 22,
    "show_more": true,
    "numerical": true,
    'validation': {
      'pies65' : {
        max: 999,
        message: "Return Pack Size maximum cannot be greater than 999"
      }
    },
    "lookup": null
  },
  {
    "field_map": "rpq",
    "item_name": "RPQ.EN",
    "title": "Return Pack Size",
    "hint_detail": "Pack Size (Quantity of Eaches) in which item must be returned.",
    "hint_panel" : "Pack Size (Quantity of Eaches) in which item must be returned.",
    "example": "",
    "sequence": 23,
    "show_more": true,
    "numerical": true,
    'validation': {
      'pies65' : {
        max: 999,
        message: "Return Pack Size maximum cannot be greater than 999"
      }
    },
    "lookup": null
  },
  {
    "field_map": "whs",
    "item_name": "WHS.EN",
    "title": "Supplier Warehouse ID",
    "hint_detail": "Logical or Physical warehouse information. Not required if all items ship with same lead time. Required if lead times vary across different items based on pick time, ship time, transit times, make times, etc.",
    "hint_panel" : "Logical or Physical warehouse information. Not required if all items ship with same lead time. Required if lead times vary across different items based on pick time, ship time, transit times, make times, etc.",
    "example": "",
    "sequence": 24,
    "show_more": true,
    'validation': {
      'pies65' : {
        minLength: 1,
        maxLength: 25,
        message: 'Supplier Warehouse ID code must be between 1 and 25 characters.'
      }
    },
    "lookup": null
  },
  {
    "field_map": "vmi",
    "item_name": "VMI.EN",
    "title": "Alert Code",
    "hint_detail": "Used in Vendor Managed Inventory Files - 3 character Alphanumeric Trading Partner Defined Code.",
    "hint_panel" : "Used in Vendor Managed Inventory Files - 3 character Alphanumeric Trading Partner Defined Code",
    "example": "",
    "sequence": 25,
    "show_more": true,
    'validation': {
      'pies65' : {
        length: 3,
        message: "Alert code must be exactly 3 characters."
      }
    },
    "lookup": null
  },
  {
    "field_map": "ecn",
    "item_name": "ECN.EN",
    "title": "ECCN",
    "hint_detail": "Enter appropriate export control classification number.",
    "hint_panel" : "Enter appropriate export control classification number.",
    "example": "",
    "sequence": 26,
    "show_more": true,
    'validation': {
      'pies65' : {
        length: 5,
        message: "ECCN code must be exactly 5 characters."
      }
    },
    "lookup": null
  },
  {
    "field_map": "gct",
    "item_name": "GCT.EN",
    "title": "Green Certification, Regulation or Standard Met",
    "hint_detail": "Green Certification, Regulation or Standard Met",
    "hint_panel" : "Green Certification, Regulation or Standard Met",
    "example": "",
    "sequence": 27,
    "show_more": true,
    "lookup": [
      { 'option': '', 'title': '-' },
      {
        "option": "OTC",
        "title": "OTC Compliant"
      },
      {
        "option": "ESTAR",
        "title": "Product has earned the Energy Star Label"
      },
      {
        "option": "NEMA",
        "title": "Meets NEMA Premium Efficiency Standards"
      },
      {
        "option": "NESHAP",
        "title": "NESHAP Compliant"
      },
      {
        "option": "LADCO",
        "title": "LADCO Compliant"
      },
      {
        "option": "FEMP",
        "title": "Meets Federal Energy Management Program (FEMP) energy efficiency levels"
      },
      {
        "option": "GSC",
        "title": "Green Seal Certified"
      },
      {
        "option": "ECO",
        "title": "EcoLogo Certified"
      }
    ]
  },
  {
    "field_map": "gpv",
    "item_name": "GPV.EN",
    "title": "Additional Green Attributes",
    "hint_detail": "Additional Green Attributes",
    "hint_panel" : "Additional Green Attributes",
    "example": "",
    "sequence": 27,
    "show_more": true,
    "lookup": [
      { 'option': '', 'title': '-' },
      {
        "option": "NTX",
        "title": "Non-toxic"
      },
      {
        "option": "REC",
        "title": "Recycled Content"
      },
      {
        "option": "BIO",
        "title": "Biobased"
      },
      {
        "option": "ENR",
        "title": "Energy Reduction"
      },
      {
        "option": "DEG",
        "title": "Biodegradable"
      }
    ]
  },
];
/* eslint-enable */
